import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
  CloseFullscreen,
  Close,
  OpenInNew,
  Toll,
  TrendingUpSharp,
  TrendingDownSharp,
  TrendingFlatSharp,
  LinkOffOutlined,
  LinkRounded,
  KeyboardArrowDown,
  KeyboardArrowRight,
  ArrowDropDownCircleOutlined,
  ExpandMore,
  ExpandMoreOutlined,
  ExpandLessOutlined,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Tooltip as MUITooltip } from "@mui/material";
import { styled } from "@mui/system";
// import { TrendingDown, Minus, PieChart, ChevronDown ,X} from 'lucide-react';
import { TypeAnimation } from "react-type-animation";
import bggenai from "../../assets/bggenai.png";
import bgsd from "../../assets/bgsd.png";
import ailoader from "../../assets/ailoader.gif";
import { TbTopologyStar3 } from "react-icons/tb";
// import { PieChart, Pie, Tooltip, Legend } from 'recharts';
import { PieChartComponent } from "./PieChartComponent";
import gs from "../../assets/gs.png";
import { useFileContext } from "./FileContext";
import sourceicon from "../../assets/source.png";
import { useDashboardUiState } from "./dashboardUiState";
// In each component (InsightContainer, CommodityChart, PorterForces)
import { useAtom } from "jotai";
import { selectedCategoryAtomFamily } from "./atoms";
import { PorterForces } from "./PorterForces";
import { CommodityPriceChart } from "./CommodityPriceChart";
import { Key } from "lucide-react";

export const InsightContainer = ({
  title,
  topCategories,
  topContributors,
  marketSize,
  categoryDict,
  costStructure,
  demandandSupply,
  topSuppliers,
  categoryChartData,
  clientNames,
  categoryNews,
  indiSummaries,
  globalSummaries,
  csSrc,
  porterForces,
  catandSpend,
  marketImplications,
  filteredResults,
  costStructureMovements,
}) => {
  const fileContext = useFileContext();
  const filenameKey = fileContext?.filename ?? "global";
  const [selectedCategory, setSelectedCategory] = useAtom(
    selectedCategoryAtomFamily(filenameKey)
  );
  const [showNewsOverlay, setShowNewsOverlay] = useState(false);
  const [selectedMainCategoryIndex, setSelectedMainCategoryIndex] =
    useDashboardUiState(
      `rapidInsights:${filenameKey}:categoryInsights:selectedMainCategoryIndex`,
      0
    );
  const [selectedL3CategoryIndex, setSelectedL3CategoryIndex] =
    useDashboardUiState(
      `rapidInsights:${filenameKey}:categoryInsights:selectedL3CategoryIndex`,
      0
    );
  const [selectedL3Category, setSelectedL3Category] = useDashboardUiState(
    `rapidInsights:${filenameKey}:categoryInsights:selectedL3Category`,
    null
  );
  const [isddOpen, setIsddOpen] = useState(false);
  const [showSubcategories, setShowSubcategories] = useState(false);

  console.log("topCategories", categoryDict);

  useEffect(() => {
    if (selectedL3Category != null) return;
    if (!topCategories || topCategories.length === 0) return;

    const firstMainCategory = Object.keys(topCategories[0] ?? {})[0];
    if (firstMainCategory) {
      setSelectedL3Category(firstMainCategory);
    }
  }, [selectedL3Category, setSelectedL3Category, topCategories]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isddOpen && !event.target.closest(".category-dropdown")) {
        setIsddOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isddOpen]);

  //   const globalSummaries={
  //     "Sweeteners": {
  //         "Sweeteners": {
  //             "Sweeteners": {
  //                 "Pricing": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Aspartame prices are climbing due to increased demand, limited inventories, higher feedstock prices, and regulatory changes impacting the market."
  //                     }
  //                 ],
  //                 "Supply Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Aspartame imports are surging steadily, supported by ease in freight costs and increased volumes from China and Japan."
  //                     }
  //                 ],
  //                 "Demand Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Demand is rising due to health trends, holiday season production, and stockpiling behavior amid potential regulatory changes."
  //                     }
  //                 ],
  //                 "Supply Chain Overview": [
  //                     "Supply chain disruptions and increased demand can lead to potential shortages. However, ease in freight costs supports import growth, mitigating some supply chain risks."
  //                 ],
  //                 "Regulatory Environment": [
  //                     "Ongoing discussions about potential new regulations on artificial sweeteners are influencing stockpiling behavior and demand."
  //                 ],
  //                 "ESG": [
  //                     "The shift towards sugar reduction and natural sweeteners aligns with health and wellness trends, promoting sustainable consumption patterns."
  //                 ]
  //             },
  //             "Syrup": {
  //                 "Pricing": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Tariffs on Canadian imports, including maple syrup, are expected to increase prices due to higher import costs."
  //                     }
  //                 ],
  //                 "Supply Trend": [
  //                     {
  //                         "Indicator": "D",
  //                         "Reason": "Tariffs on Canadian goods may disrupt supply chains, leading to decreased availability of syrup in North America."
  //                     }
  //                 ],
  //                 "Demand Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Growing consumer interest in flavored syrups for beverages and culinary applications is driving demand in North America."
  //                     }
  //                 ],
  //                 "Supply Chain Overview": [
  //                     "Tariffs on Canadian imports could disrupt syrup supply chains, increasing costs and reducing availability. Companies may need to explore alternative sourcing strategies."
  //                 ],
  //                 "Regulatory Environment": [
  //                     "The US FDA's ban on red dye 3 in food products by 2027 may impact syrup formulations and labeling requirements."
  //                 ],
  //                 "ESG": [
  //                     "Sustainable practices in syrup production, such as using the entire cocoa fruit, are gaining attention for reducing waste and supporting farmer incomes."
  //                 ]
  //             },
  //             "Polyols": {
  //                 "Pricing": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Technological advancements and increased demand for health-conscious products are driving up Polyol prices, as manufacturers invest in innovations to meet consumer preferences."
  //                     }
  //                 ],
  //                 "Supply Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Synthetic Polyols' cost-effectiveness and reliable supply chain, primarily from petrochemical sources, ensure a stable and increasing supply trend."
  //                     }
  //                 ],
  //                 "Demand Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Rising consumer awareness and demand for sugar-free, low-calorie products in food and personal care sectors are driving increased Polyol demand."
  //                     }
  //                 ],
  //                 "Supply Chain Overview": [
  //                     "Synthetic Polyols' reliance on petrochemical sources provides a stable supply chain, but geopolitical tensions or natural disasters affecting oil supply could pose risks."
  //                 ],
  //                 "Regulatory Environment": [
  //                     "Increasing regulatory standards for sustainable construction practices are driving demand for Polyols in energy-efficient building materials."
  //                 ],
  //                 "ESG": [
  //                     "The trend towards eco-friendly construction and bio-based Polyols aligns with sustainability goals, enhancing the market's environmental and social governance profile."
  //                 ]
  //             },
  //             "Starch": {
  //                 "Pricing": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Rising demand for clean label starch and increasing production costs are driving prices up, as consumers seek natural and minimally processed ingredients."
  //                     }
  //                 ],
  //                 "Supply Trend": [
  //                     {
  //                         "Indicator": "N",
  //                         "Reason": "Stable supply expected due to consistent production levels and no significant disruptions reported in the starch supply chain."
  //                     }
  //                 ],
  //                 "Demand Trend": [
  //                     {
  //                         "Indicator": "I",
  //                         "Reason": "Growing consumer preference for clean label and natural ingredients is boosting demand for starch in food and beverage applications."
  //                     }
  //                 ],
  //                 "Supply Chain Overview": [
  //                     "The supply chain for starch in North America remains stable with no major disruptions. However, rising production costs and demand for natural ingredients could pressure supply chains."
  //                 ],
  //                 "Regulatory Environment": [
  //                     "Stricter food labeling regulations are pushing manufacturers to adopt clean label starch, impacting supply and demand dynamics."
  //                 ],
  //                 "ESG": [
  //                     "The shift towards clean label starch aligns with sustainability goals, as it reduces reliance on synthetic additives and promotes natural ingredient sourcing."
  //                 ]
  //             }
  //         }
  //     }
  // }

  // const categoryNews={
  //   "Sweeteners": {
  //       "Sweeteners": {
  //           "Sweeteners": [
  //               {
  //                   "title": "Aspartame Prices are likely to Rise Steadily Across North America In September",
  //                   "link": "https://www.chemanalyst.com/NewsAndDeals/NewsDetails/aspartame-prices-are-likely-to-rise-steadily-across-north-america-in-september-30326",
  //                   "snippet": "In a notable shift within the artificial sweetener market, Aspartame prices have been climbing steadily, coinciding with a consistent increase in imports...",
  //                   "date": "6 months ago",
  //                   "source": "ChemAnalyst",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTwHsoBeDHPq6mP15is9eV0Is9VsIkXRRyd4NZyRzA3zdKfEBBy_VMbtnQNJw&s",
  //                   "position": 1,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "North America Sugar-Free Chewing Gum Report 2025: Market Projected to Reach US$ 3.53 Billion by 2033",
  //                   "link": "https://www.globenewswire.com/news-release/2025/03/13/3042109/0/en/North-America-Sugar-Free-Chewing-Gum-Report-2025-Market-Projected-to-Reach-US-3-53-Billion-by-2033.html",
  //                   "snippet": "Dublin, March 13, 2025 (GLOBE NEWSWIRE) -- The.",
  //                   "date": "3 weeks ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXec9wgjWqw16NpX7mgZkKEC1-qMywH_GXV45fPh64C8LL--zVIvUNOj6l1g&s",
  //                   "position": 2,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Artificial Sweeteners Market Set to Soar to USD 22 Billion by 2031, Driven by Rising Health Trends: Market Research Intellect",
  //                   "link": "https://www.prnewswire.com/news-releases/artificial-sweeteners-market-set-to-soar-to-usd-22-billion-by-2031-driven-by-rising-health-trends-market-research-intellect-302253104.html",
  //                   "snippet": "The Artificial Sweeteners Market is experiencing significant growth, driven by several key factors. Rising health consciousness among consumers is a primary...",
  //                   "date": "6 months ago",
  //                   "source": "PR Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmtvzdyPlgrXqTzqqe-UMjwEDw6lXAD95Ki7vZ2Vqr-S1qxSbcPqD0uhAd&s",
  //                   "position": 3,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Artificial sweetener market forecast for major growth to $22 billion by 2031",
  //                   "link": "https://www.confectioneryproduction.com/news/49800/artificial-sweetener-market-forecast-for-major-growth-to-22-billion-by-2031/",
  //                   "snippet": "A significant positive shift in the artificial sweeteners market has been projected, as latest industry figures forecast a global market size to show...",
  //                   "date": "6 months ago",
  //                   "source": "Confectionery Production",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiwwVJswrDqS_9Yw1VQQ5dvMy6EGbc3X21a7NER3FH7EHwukxWSgozsMh-Mg&s",
  //                   "position": 4,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Confectionery Statistics and Facts (2025)",
  //                   "link": "https://www.news.market.us/confectionery-statistics/",
  //                   "snippet": "The global market is projected to grow significantly, driven by rising disposable incomes, particularly in North America, Europe, and Asia-Pacific.",
  //                   "date": "5 months ago",
  //                   "source": "Market.us",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFdbHf2DkF-fj5YANxcGCPqWOKw4nOiODlafJzaf51ic59-V8OnXT7Dqzbwg&s",
  //                   "position": 5,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "What RFK Jr.'s War on Corn Syrup Could Mean for Your Grocery Basket",
  //                   "link": "https://www.investopedia.com/rfk-s-war-on-corn-syrup-8762408",
  //                   "snippet": "Robert F. Kennedy Jr.'s plan to combat obesity and chronic diseases by targeting high-fructose corn syrup could mean changes in Americans' grocery baskets.",
  //                   "date": "2 months ago",
  //                   "source": "Investopedia",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5XS8mXerXtsvI_bEZMZ4NwRZzywkiLDUCIQM-vb_w7SEI3BiRDduYatc9Sg&s",
  //                   "position": 6,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Costly US Sugar Tariffs Drive Candy Makers Over the Border to Canada",
  //                   "link": "https://www.bloomberg.com/news/articles/2024-06-08/us-sugar-tariffs-make-canada-more-attractive-place-to-manufacture-candy",
  //                   "snippet": "Sweets production has expanded in Canada as companies look to supply sugar-hungry North American households while avoiding US protectionist policies.",
  //                   "date": "9 months ago",
  //                   "source": "Bloomberg",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2kXBTTD6-EFAhM0vlntLrqLKJczFlxEsW8Ujp-FIfMeIjKeyUv7Pl2ejeMw&s",
  //                   "position": 7,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Sucralose Market to Reach USD 6.25 Billion by 2033; Emergence of Functional and Fortified Foods to Propel Growth",
  //                   "link": "https://www.globenewswire.com/news-release/2024/04/10/2861166/0/en/Sucralose-Market-to-Reach-USD-6-25-Billion-by-2033-Emergence-of-Functional-and-Fortified-Foods-to-Propel-Growth.html",
  //                   "snippet": "The sucralose market size is anticipated to grow from USD 3.73 Billion in 23 to USD 6.25 Billion in 10 years. The market ought to witness a positive growth.",
  //                   "date": "11 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMf7Iq2CUeV84ithrBe7R_WX4bcZFNrFE8MRWqCPo9q9yp8tGqnTRcybCm&s",
  //                   "position": 8,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Monk Fruit Sweeteners Market to Reach $147.2 Million by 2032 - Exclusive Report by Meticulous Research",
  //                   "link": "https://www.prnewswire.com/news-releases/monk-fruit-sweeteners-market-to-reach-147-2-million-by-2032---exclusive-report-by-meticulous-research-302386060.html",
  //                   "snippet": "PRNewswire/ -- According to a new market research report titled, 'Monk Fruit Sweeteners Market Size, Share, Forecast, & Trends Analysis by Product Type...",
  //                   "date": "1 month ago",
  //                   "source": "PR Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5NTvJYMB7PQScO6pEZPVhvr94ox7Xgp2kuxDTDCeC4pHlJv6Lm4VWNe44uA&s",
  //                   "position": 9,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Barry Callebaut posts quarterly sales decline amid ongoing cocoa price surge",
  //                   "link": "https://www.confectioneryproduction.com/news/51243/barry-callebaut-posts-quarterly-sales-decline-amid-ongoing-cocoa-price-surge/",
  //                   "snippet": "The Swiss-based Barry Callebaut Group has reported a further sales dip, with volumes for the first quarter of its 2024/25 year being down 2.7, to 565,238...",
  //                   "date": "2 months ago",
  //                   "source": "Confectionery Production",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTB43BKxZgwsztHN6DInMYqoy1wmwN5z723Iju5DjFmtXychEKH_JMqVQJcNQ&s",
  //                   "position": 10,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Alternative Sweeteners Industry Analysis, Trends, Developments and Opportunities to 2029 - Rising Demand for Natural Ingredients Fuels Growth of Local Vendors, Intensifying Global Market Competition",
  //                   "link": "https://www.globenewswire.com/news-release/2024/11/01/2973233/28124/en/Alternative-Sweeteners-Industry-Analysis-Trends-Developments-and-Opportunities-to-2029-Rising-Demand-for-Natural-Ingredients-Fuels-Growth-of-Local-Vendors-Intensifying-Global-Marke.html",
  //                   "snippet": "The Alternative Sweetener Market was valued at USD 10.49 billion in 2023, and is expected to reach USD 14.71 billion by 2029, rising at a CAGR of 5.80%.",
  //                   "date": "5 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0E65TyTLbLIJS3Vt_gGgTiZzRzkgj7vdSXWlxyjZP8ONu_amZ37MLcrJkUw&s",
  //                   "position": 6,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Artificial Sweetener Market to Surge to US$ 10.30 Billion by 2032 | 2024 Industry Report",
  //                   "link": "https://www.globenewswire.com/news-release/2024/09/04/2940701/28124/en/Artificial-Sweetener-Market-to-Surge-to-US-10-30-Billion-by-2032-2024-Industry-Report.html",
  //                   "snippet": "Recent industry analysis reveals significant growth in the global artificial sweetener market, with projected values reaching US$ 10.30 Billion by the year...",
  //                   "date": "6 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxmPLzLZgaX_Y8QZPB9ZmFRnkv8Lw__REQFJ2qfAu_fmgG28sG3ztPzDMzmA&s",
  //                   "position": 8,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "[Latest] Global Sugar Substitute Market Size/Share Worth USD 12,458.9 Million by 2034 at a 5.28% CAGR: Custom Market Insights (Analysis, Outlook, Leaders, Report, Trends, Forecast, Segmentation, Growth, Growth Rate, Value)",
  //                   "link": "https://www.globenewswire.com/news-release/2025/02/11/3024419/0/en/Latest-Global-Sugar-Substitute-Market-Size-Share-Worth-USD-12-458-9-Million-by-2034-at-a-5-28-CAGR-Custom-Market-Insights-Analysis-Outlook-Leaders-Report-Trends-Forecast-Segmentati.html",
  //                   "snippet": "[220+ Pages Latest Report] According to a market research study published by Custom Market Insights, the demand analysis of Global Sugar Substitute Market.",
  //                   "date": "1 month ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSN_YyZzvXHRFk4qRthRCg-SQ3vu29gs-Y88DQecD-LEgufWidzPXb521Wb1Q&s",
  //                   "position": 9,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Cargill: Upgrading for the Changing Chocolate Market, pt 1",
  //                   "link": "https://manufacturingdigital.com/articles/cargill-facility",
  //                   "snippet": "Part one of how Cargill has expanded facilities and launched a new production line to meet global confectionary trends.",
  //                   "date": "5 months ago",
  //                   "source": "Manufacturing Digital Magazine",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRf8VgVRaRdZVXHYjqlKebfLQA9QkALA35KhXNOfKCqbQ&s",
  //                   "position": 5,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Palm Sugar Market Set to Reach US$ 2,850.6 Mn by 2033 as Natural",
  //                   "link": "https://www.openpr.com/news/3938397/palm-sugar-market-set-to-reach-us-2-850-6-mn-by-2033-as-natural",
  //                   "snippet": "The global palm sugar market has seen steady growth in recent years, driven by increased demand for natural sweeteners and a shift toward healthier food...",
  //                   "date": "1 week ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNMzCCqP-XB8KBJIljCKc9O5vNlYbXRXjE0ZBQ6vogOCcoDlbZBaVOB2eJrA&s",
  //                   "position": 6,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Invert Sugar Market to Reach New Heights with Increasing Demand from Food & Beverage Industry | Future Market Insights, Inc.",
  //                   "link": "https://www.accessnewswire.com/newsroom/en/food-and-beverage-products/invert-sugar-market-to-reach-new-heights-with-increasing-demand-from-food-913815",
  //                   "snippet": "Inverted sugar or sugar syrup is a liquid sweetener made from granulated table sugar and water. It is widely used in food products such as bakery...",
  //                   "date": "2 months ago",
  //                   "source": "ACCESS Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGY4N1GyhbPRx912DG5oC4F9dbMPjdwj2sapCgPW5E-AMpDTdERQmnSJBztw&s",
  //                   "position": 7,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Sugar Substitutes Market Surges to USD 25.4 Billion by 2031, Propelled by 4.42% CAGR - Verified Market Research®",
  //                   "link": "https://www.globenewswire.com/news-release/2024/09/17/2947574/0/en/Sugar-Substitutes-Market-Surges-to-USD-25-4-Billion-by-2031-Propelled-by-4-42-CAGR-Verified-Market-Research.html",
  //                   "snippet": "The Sugar Substitutes Market is driven by increasing health consciousness, rising cases of diabetes and obesity, and growing demand for low-calorie and...",
  //                   "date": "6 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbl6xFPT58FDJUAw5tQ6EgjLmT7hQ36qG5tc3WlwhGuJFamhpoBznsFCSQGg&s",
  //                   "position": 8,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Rising demand for sugar reduction: Opportunities and obstacles for the industry",
  //                   "link": "https://www.foodincanada.com/features/rising-demand-for-sugar-reduction-opportunities-and-obstacles-for-the-industry/",
  //                   "snippet": "By Nithya Caleb August 21, 2024. Food Trends Bake & Snack Food Beverages Confectionery Dairy Fruit & Vegetables Health & Wellness Ingredients & Additives...",
  //                   "date": "7 months ago",
  //                   "source": "Food In Canada",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM-FYPZMKDqvl_THsOaIwdJWDmzIVcXp-l3MxBKwTYrf2fIYO8PRFtn1XhZA&s",
  //                   "position": 9,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Strategic investment enhances Döhler’s North American operations",
  //                   "link": "https://www.confectioneryproduction.com/news/52241/strategic-investment-enhances-dohlers-north-american-operations/",
  //                   "snippet": "Ingredients group Döhler North America has unveiled its plans for expansion with a key acquisition of Premier Juices, strengthening its offerings in natural...",
  //                   "date": "1 day ago",
  //                   "source": "Confectionery Production",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSbKSQzgBnfs9amoTaVIHah_wESMktyRpfxHRWVjYCCd5AFWbDtGTf1WLlE5g&s",
  //                   "position": 3,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Barry Callebaut announces U.S. government relations lead",
  //                   "link": "https://www.snackandbakery.com/articles/113363-barry-callebaut-announces-us-government-relations-lead",
  //                   "snippet": "Shorts will lead Barry Callebaut's U.S. government affairs strategy, working closely with policymakers, industry coalitions, and regulatory bodies to...",
  //                   "date": "2 days ago",
  //                   "source": "Snack Food & Wholesale Bakery",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRlmtpmhtXPmNoo8QQ2J3SHWUACiEGuIIdSfZOThuyvn1PwqcWHMdgkwFsuw&s",
  //                   "position": 4,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Voyage Foods Pens Deal with Cargill to Expand Cocoa-Free Chocolate & Nut-Free Spreads",
  //                   "link": "https://www.greenqueen.com.hk/voyage-foods-cargill-cocoa-free-chocolate-nut-spreads/",
  //                   "snippet": "Cargill has announced a commercial partnership with Voyage Foods to extend its confectionery portfolio by entering the cocoa-free chocolate market for the...",
  //                   "date": "11 months ago",
  //                   "source": "Green Queen",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLBax1WY5l9BGnCP7zvEg7TL1DOHpL_CxWip8fXPtr0JZlyEk3tTYW1VcnNg&s",
  //                   "position": 6,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Hershey records upward growth across US and global sales with annual results",
  //                   "link": "https://www.confectioneryproduction.com/news/51539/hershey-record-upward-growth-across-us-and-global-sales-with-annual-results/",
  //                   "snippet": "US confectionery giant, Hershey, has released its latest annual financial results revealing an upturn in performance, producing net sales of $11.2 billion.",
  //                   "date": "1 month ago",
  //                   "source": "Confectionery Production",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCLoDXmeeb4OITk8m4Y3csety-2Q0rOR99HQ3O_YveUQHcAMhX1b-G-T3EmQ&s",
  //                   "position": 9,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Tagatose Market Size Worth $294.67 Billion by 2033 | CAGR: 6.10% by The Brainy Insights",
  //                   "link": "https://finance.yahoo.com/news/tagatose-market-size-worth-294-030000183.html",
  //                   "snippet": "The tagatose market is experiencing significant growth, driven by increasing consumer demand for natural sweeteners. The market is poised to expand as more...",
  //                   "date": "8 months ago",
  //                   "source": "Yahoo Finance",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSz_lCgaLzHxniIkKPNBm_XGU14HvdQi2Ljs2EAol6meoJU6lx7vm1WUYNW&s",
  //                   "position": 7,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Industrial Granulated Sugar Market to Reach USD 50 Billion by 2031, Driven by 5% CAGR and Surging Demand Across Food, Pharmaceutical, and Emerging Market: - Market Research Intellect",
  //                   "link": "https://www.prnewswire.com/news-releases/industrial-granulated-sugar-market-to-reach-usd-50-billion-by-2031-driven-by-5-cagr-and-surging-demand-across-food-pharmaceutical-and-emerging-market---market-research-intellect-302299886.html",
  //                   "snippet": "PRNewswire/ -- The Industrial Granulated Sugar Market is expected to grow at a compound annual growth rate (CAGR) of approximately 5% from 2024 to 2031.",
  //                   "date": "4 months ago",
  //                   "source": "PR Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmtvzdyPlgrXqTzqqe-UMjwEDw6lXAD95Ki7vZ2Vqr-S1qxSbcPqD0uhAd&s",
  //                   "position": 9,
  //                   "query_key": "production"
  //               }
  //           ],
  //           "Syrup": [
  //               {
  //                   "title": "Flavored Syrup Market to Reach US$ 89.48 Billion by 2034, Expanding at 5.2% CAGR - Fact.MR Report",
  //                   "link": "https://www.globenewswire.com/news-release/2025/02/06/3022131/0/en/Flavored-Syrup-Market-to-Reach-US-89-48-Billion-by-2034-Expanding-at-5-2-CAGR-Fact-MR-Report.html",
  //                   "snippet": "Demand for flavored syrups is increasing continuously due to the increasing number of coffee shops and beverage chains in several countries ...",
  //                   "date": "1 month ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2jR-CXzA9e-daHfgv0uybZeKj_2Y2ZaB0qiBsh-fej-uUanuVaopliJRlaw&s",
  //                   "position": 1,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Rice Syrup Market Size & Share, Global Industry Report 2032",
  //                   "link": "https://www.gminsights.com/industry-analysis/rice-syrup-market",
  //                   "snippet": "Rice Syrup Market Size - By Rice Type (Brown Rice, White Rice), By Source (Organic, Conventional), By Application (Bakery & Confectionery, Dairy Products, Meat...",
  //                   "date": "11 months ago",
  //                   "source": "Global Market Insights Inc.",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvnEGD9fl73cIm9vUQPbwhI7SOxhdGoUgy1dpfOpOnsUZXx5m00lgzKcS11Q&s",
  //                   "position": 2,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Swiss chocolate: Scientists cut waste and sugar",
  //                   "link": "https://www.bbc.com/news/articles/cn47zg3xgxxo",
  //                   "snippet": "Food scientists in Switzerland have come up with a way to make chocolate using the entire cocoa fruit rather than just the beans - and without using sugar.",
  //                   "date": "7 months ago",
  //                   "source": "BBC",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxffE9Fa9q13aodJ09pF06zpplpqP7u5H5_xRphQvY4URQyoB1UtuloGxv-g&s",
  //                   "position": 3,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Cocoa prices impacting Hershey’s 2025 forecast",
  //                   "link": "https://www.foodbusinessnews.net/articles/27654-cocoa-prices-impacting-hersheys-2025-forecast",
  //                   "snippet": "But company has no concerns about the global physical supply of cocoa.",
  //                   "date": "1 month ago",
  //                   "source": "Food Business News",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_9B-zpfurgW8prRHtRajXWb5bCZZMcF6rfEgKS_wQNLAZ1cq9k77GvC1qOw&s",
  //                   "position": 4,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Invert Sugar Market to Reach New Heights with Increasing Demand from Food & Beverage Industry | Future Market Insights, Inc.",
  //                   "link": "https://www.accessnewswire.com/newsroom/en/food-and-beverage-products/invert-sugar-market-to-reach-new-heights-with-increasing-demand-from-food-913815",
  //                   "snippet": "Inverted sugar or sugar syrup is a liquid sweetener made from granulated table sugar and water. It is widely used in food products such as bakery...",
  //                   "date": "2 months ago",
  //                   "source": "ACCESS Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGY4N1GyhbPRx912DG5oC4F9dbMPjdwj2sapCgPW5E-AMpDTdERQmnSJBztw&s",
  //                   "position": 5,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Alternative Sweeteners Industry Analysis, Trends, Developments and Opportunities to 2029 - Rising Demand for Natural Ingredients Fuels Growth of Local Vendors, Intensifying Global Market Competition",
  //                   "link": "https://www.globenewswire.com/news-release/2024/11/01/2973233/28124/en/Alternative-Sweeteners-Industry-Analysis-Trends-Developments-and-Opportunities-to-2029-Rising-Demand-for-Natural-Ingredients-Fuels-Growth-of-Local-Vendors-Intensifying-Global-Marke.html",
  //                   "snippet": "The Alternative Sweetener Market was valued at USD 10.49 billion in 2023, and is expected to reach USD 14.71 billion by 2029, rising at a CAGR of 5.80%.",
  //                   "date": "5 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0E65TyTLbLIJS3Vt_gGgTiZzRzkgj7vdSXWlxyjZP8ONu_amZ37MLcrJkUw&s",
  //                   "position": 6,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Global Food Coating Ingredients Market to Reach USD 10.58 Billion by 2035, Driven by Rising Demand for Enhanced Food Appearance and Shelf Life | Future Market Insights Inc.",
  //                   "link": "https://finance.yahoo.com/news/global-food-coating-ingredients-market-143000102.html",
  //                   "snippet": "The global food coating ingredients market is set for steady growth, with sales rising at a 6.7% CAGR from 2025 to 2035. Driven by globalization, evolving...",
  //                   "date": "1 month ago",
  //                   "source": "Yahoo Finance",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmih1t3YtUweAYpg6USnO0XQt6ZTUX1n4HP55tWxahKGQPQMSA6Rn13omjcA&s",
  //                   "position": 3,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Maple Syrup Market to Expand Annually by 6.4% from 2025 to 2032, SkyQuest Technology",
  //                   "link": "https://www.openpr.com/news/3909202/maple-syrup-market-to-expand-annually-by-6-4-from-2025-to-2032",
  //                   "snippet": "According to SkyQuest Technology Group, Maple Syrup Market size is poised to grow from USD 1.7 billion in 2024 to USD 2.8 billion by 2032, growing at a CAGR...",
  //                   "date": "3 weeks ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXBX8JfuigX8ib-nIq_Hzc42tgEtaXQO3Wp9fGgujJV9MygBwo9pGY3OMIzw&s",
  //                   "position": 4,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Global Popping Candy Market Size To Worth USD 3,901.73 Million By 2033 | CAGR of 4.15%",
  //                   "link": "https://www.globenewswire.com/news-release/2024/07/15/2913286/0/en/Global-Popping-Candy-Market-Size-To-Worth-USD-3-901-73-Million-By-2033-CAGR-of-4-15.html",
  //                   "snippet": "The Global Popping Candy Market Size was Valued at USD 2598.64 Million in 2023 and the Worldwide Popping Candy Market Size is Expected to Reach USD...",
  //                   "date": "8 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkyJywylZsxjglejTHvu6gC8J24zX4fsgZ8o_3f_TJrnznha8Pm_QJ0h2-aw&s",
  //                   "position": 5,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Chocolate Milk Market Size and Forecasts (2021 - 2031), Global",
  //                   "link": "https://www.openpr.com/news/3952189/chocolate-milk-market-size-and-forecasts-2021-2031-global",
  //                   "snippet": "Press release - The Insight Partners - Chocolate Milk Market Size and Forecasts (2021 - 2031), Global and Regional Share, Trends, and Growth Opportunity...",
  //                   "date": "1 hour ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmQfLteS2MbBo3UMh843V4ARNzb5vlveXV7MVSCAwmktCxT3YupwiPqWRUMg&s",
  //                   "position": 7,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Glucose-Fructose Syrup Market Poised for Growth Driven by",
  //                   "link": "https://www.globenewswire.com/news-release/2024/11/04/2974178/0/en/Glucose-Fructose-Syrup-Market-Poised-for-Growth-Driven-by-Diverse-Applications-in-Divers-Industry-Future-Market-Insights-Inc.html",
  //                   "snippet": "Germany's glucose-fructose syrup market is set to grow at a 1.9% CAGR from 2024 to 2034, driven by the strong food and beverage sector.",
  //                   "date": "4 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPexoh-XdiJRuZQUZxGdQl_hUotVE_yLYvBTArxRulnyxmFVqt7u4LNTJ-kg&s",
  //                   "position": 8,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Agave Syrup Market Anticipated to Reach US$ 1,021.5 Mn by 2032",
  //                   "link": "https://www.openpr.com/news/3948818/agave-syrup-market-anticipated-to-reach-us-1-021-5-mn-by-2032",
  //                   "snippet": "The global agave syrup market is witnessing rapid growth as consumer demand shifts toward healthier and more natural sweetening alternatives.",
  //                   "date": "1 day ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdaeLCIq7BtJM8zYqHsAzRuGT5N1A2_r7t1o93o-FAU2x-dsk6YjW1ISGjRw&s",
  //                   "position": 9,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "2025 Analysis of the World Market for Fillings and Toppings",
  //                   "link": "https://www.globenewswire.com/news-release/2025/02/26/3032805/28124/en/2025-Analysis-of-the-World-Market-for-Fillings-and-Toppings-by-Type-Flavour-Form-Application-and-Region-Includes-Growth-Forecasts-to-2029-and-2034.html",
  //                   "snippet": "Dublin, Feb. 26, 2025 (GLOBE NEWSWIRE) -- The.",
  //                   "date": "1 month ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPNnt0j6OX3dtoM-yX8ezQKbROsB4uPX3I0PrJlvR55RM7FxXzsS8bvMEpIw&s",
  //                   "position": 10,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "What RFK Jr.'s War on Corn Syrup Could Mean for Your Grocery Basket",
  //                   "link": "https://www.investopedia.com/rfk-s-war-on-corn-syrup-8762408",
  //                   "snippet": "Robert F. Kennedy Jr.'s plan to combat obesity and chronic diseases by targeting high-fructose corn syrup could mean changes in Americans' grocery baskets.",
  //                   "date": "2 months ago",
  //                   "source": "Investopedia",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5XS8mXerXtsvI_bEZMZ4NwRZzywkiLDUCIQM-vb_w7SEI3BiRDduYatc9Sg&s",
  //                   "position": 3,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "As Tariffs Slam Maple Syrup, Sugarmakers Branch Out",
  //                   "link": "https://civileats.com/2025/03/05/branching-out-beyond-maple-syrup/",
  //                   "snippet": "US sugarmakers expand into alternative tree syrups to fortify their businesses in the face of climate change and newly implemented tariffs.",
  //                   "date": "1 month ago",
  //                   "source": "Civil Eats",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQao7gbi32-DgMnaynDxIm8AwhZQjxPcyFYpy8YKIlijso4KtDP5_0eBsQ8kA&s",
  //                   "position": 2,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Hershey Sales Get Boost From High Prices on Cocoa Shortage",
  //                   "link": "https://www.bloomberg.com/news/articles/2024-05-03/hershey-hsy-sales-get-a-boost-from-high-prices-cocoa-rally",
  //                   "snippet": "The sharp rise in cocoa prices is leading to big gains at Hershey Co. The chocolate and salty-snack company said on Friday that its first-quarter sales and...",
  //                   "date": "10 months ago",
  //                   "source": "Bloomberg.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRswMm4PWMN0-TTCipI0NVoBoT1bdXezdS8xzGHNk0HopRr4EAWlfllsyM6aA&s",
  //                   "position": 5,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "US bans red dye No. 3 from food, candy and medicine",
  //                   "link": "https://www.bbc.com/news/articles/cx2qpngxgp4o",
  //                   "snippet": "The US has banned the use of a synthetic dye typically added to foods and beverages to give them a bright, cherry-red hue.",
  //                   "date": "2 months ago",
  //                   "source": "BBC",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmpLYwzJ5sHHh3_uukUAW3aZzbzrKZJNfzCttYSAUCSk1TqbpvO1L2nSAHcA&s",
  //                   "position": 6,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "14 Costco Groceries That Are Going To Shoot Up In Price",
  //                   "link": "https://www.thedailymeal.com/1796895/costco-groceries-going-up-price/",
  //                   "snippet": "Everyday basics like beef, pork, frozen fruit, and tomatoes set to get way more expensive. Items that are slightly more pricey, like alcohol, may also become...",
  //                   "date": "1 month ago",
  //                   "source": "The Daily Meal",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToawHXzFv3EsHmaOYH1x2cLaP2fx4Y2PQK0ixlrVLV6s06h0B8XeWBva67Qw&s",
  //                   "position": 7,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Valeo Foods Group acquires Appalaches Nature",
  //                   "link": "https://www.foodincanada.com/food-business/valeo-foods-group-acquires-appalaches-nature-157944/",
  //                   "snippet": "Valeo Foods Group, one of Europe's leading producers of sweets, treats and snacks, acquires Appalaches Nature, a Canadian maple syrup business.",
  //                   "date": "8 months ago",
  //                   "source": "Food In Canada",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRnQEjntZRpZRXcdoNt1Y53vteyNuMC7Noqya1Y2_0OpOFBIlXDoeumyFxnHA&s",
  //                   "position": 9,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Global Whey Protein Concentrate (WPC) Market Size To Worth USD 16.53 Billion By 2033 | CAGR of 10.57%",
  //                   "link": "https://www.globenewswire.com/news-release/2024/08/16/2931350/0/en/Global-Whey-Protein-Concentrate-WPC-Market-Size-To-Worth-USD-16-53-Billion-By-2033-CAGR-of-10-57.html",
  //                   "snippet": "The Global Whey Protein Concentrate (WPC) Market Size is to Grow from USD 6.05 Billion in 2023 to USD 16.53 Billion by 2033, at a Compound Annual Growth Rate (...",
  //                   "date": "7 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsHPxTxcuIdaA0nG0D5ZmYMBEHXGcyZ5qy1RT7fJiHYZj9X2Wo48R_9fLs2g&s",
  //                   "position": 10,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Gluten Free Sugar Syrup Market Size is Projected to Reach",
  //                   "link": "https://www.globenewswire.com/news-release/2025/02/19/3028824/0/en/Gluten-Free-Sugar-Syrup-Market-Size-is-Projected-to-Reach-USD-5-98-billion-by-2033-Growing-at-a-CAGR-of-6-3-Straits-Research.html",
  //                   "snippet": "The global gluten free sugar syrup market size was valued at USD 1.87 billion in 2024 and is projected to grow from USD 2.09 billion in 2025 to USD 5.98...",
  //                   "date": "1 month ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGicauCSAdlnP0FwMPSTMoKFnLceRJAmw5QAj-sCN5PIFh3GWxH18AKJkN7Q&s",
  //                   "position": 1,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "These crop ag producers are repeatedly cited for child labor violations",
  //                   "link": "https://investigatemidwest.org/2025/03/26/these-crop-ag-producers-are-repeatedly-cited-for-child-labor-violations/",
  //                   "snippet": "Nearly half of all child labor violations in the agriculture industry since 1995 have occurred in grain, fruit and vegetable farming.",
  //                   "date": "1 week ago",
  //                   "source": "Investigate Midwest",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRm97gR8ON-D7mrpOtUWLTWgGi23co_zfu4XXQbrYYD3fW5gU1LN38KOs36mA&s",
  //                   "position": 4,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Farmers Are Feeding Candy to Animals, and It’s a Symptom of Larger Issues",
  //                   "link": "https://sentientmedia.org/farmers-feeding-candy-to-animals/",
  //                   "snippet": "Some farmers end up feeding candy to their animals. Chocolate and other treats that can't be sold, or candy bits leftover from production, are being sold to...",
  //                   "date": "2 months ago",
  //                   "source": "Sentient Media",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQj1OQDs4Jp5VFYCKYoeeDYGYrxwJzov9GYU1Fbje0iG55_q9mxMnj35upEw&s",
  //                   "position": 6,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Enzymes Market Size, Share, Growth | CAGR of 5.5%",
  //                   "link": "https://market.us/report/global-enzymes-market/",
  //                   "snippet": "Global Enzymes Market By Type (Industrial Enzymes and Specialty Enzymes), By Source (Plants, Animals and Microorganism), By Product Type (Carbohydrases,...",
  //                   "date": "3 weeks ago",
  //                   "source": "Market.us",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbfsO_BQwBAZyU9h57juRi3oJrQgMmgcyq-0gZor0rC52mBpzZgMUJJJMSMA&s",
  //                   "position": 9,
  //                   "query_key": "production"
  //               }
  //           ],
  //           "Polyols": [
  //               {
  //                   "title": "Polyols Market to Reach USD 57.55 Billion by 2032, Driven",
  //                   "link": "https://www.globenewswire.com/news-release/2025/03/11/3040731/0/en/Polyols-Market-to-Reach-USD-57-55-Billion-by-2032-Driven-by-Rising-Demand-for-High-Performance-Polyurethane-Foams-SNS-Insider.html",
  //                   "snippet": "The Polyols market is driven by the growing demand for low-calorie, sugar-free products and increasing use in sustainable applications across industries...",
  //                   "date": "3 weeks ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFHTmxZO2vgrGsarLWBauG_StLH2fnk5LUAh7dDtvI_w&s",
  //                   "position": 1,
  //                   "query_key": "supply_chain"
  //               }
  //           ],
  //           "Starch": [
  //               {
  //                   "title": "Global Confectionery Market Size To Worth USD 256.2 Billion By 2033 | CAGR Of 3.01%",
  //                   "link": "https://finance.yahoo.com/news/global-confectionery-market-size-worth-073000511.html",
  //                   "snippet": "The Global Confectionery Market Size is to Grow from USD 190.5 Billion in 2023 to USD 256.2 Billion by 2033, at a Compound Annual Growth Rate (CAGR) of 3.01%...",
  //                   "date": "7 months ago",
  //                   "source": "Yahoo Finance",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTOJUcMAlMpicnA7hHZOWfN2NrPdN5abRKp5qBzda1fjw_DOODk6RhpFdOyTw&s",
  //                   "position": 1,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Global Popping Candy Market Size To Worth USD 3,901.73 Million By 2033 | CAGR of 4.15%",
  //                   "link": "https://www.globenewswire.com/news-release/2024/07/15/2913286/0/en/Global-Popping-Candy-Market-Size-To-Worth-USD-3-901-73-Million-By-2033-CAGR-of-4-15.html",
  //                   "snippet": "The Global Popping Candy Market Size was Valued at USD 2598.64 Million in 2023 and the Worldwide Popping Candy Market Size is Expected to Reach USD...",
  //                   "date": "8 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkyJywylZsxjglejTHvu6gC8J24zX4fsgZ8o_3f_TJrnznha8Pm_QJ0h2-aw&s",
  //                   "position": 2,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Clean Label Starch Market to Reach USD 2.6 Billion by 2032, Driven by Rising Demand for Transparency and Natural Ingredients | Credence Research Inc.",
  //                   "link": "https://www.prnewswire.com/news-releases/clean-label-starch-market-to-reach-usd-2-6-billion-by-2032--driven-by-rising-demand-for-transparency-and-natural-ingredients--credence-research-inc-302330605.html",
  //                   "snippet": "PRNewswire/ -- Market Size Overview The global Clean Label Starch Market is poised for significant growth, with its market size expected to increase from...",
  //                   "date": "3 months ago",
  //                   "source": "PR Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRX5g5n29-HWWDyF17UZ31_K6wPir1VAu2J-QiSvw8RJhLE4tUlsvuG8Zfsfg&s",
  //                   "position": 3,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Egg Replacement Ingredient Market Size, Share, Forecast, 2035",
  //                   "link": "https://www.alliedmarketresearch.com/egg-replacement-ingredient-market-A239380",
  //                   "snippet": "Egg Replacement Ingredient Market Expected to Register $4.9 Billion by 2035, Driven by Growing Demand for Plant-Based and Allergen-Free Alternatives.",
  //                   "date": "4 weeks ago",
  //                   "source": "Allied Market Research",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQnVh-PEt_KitASvs4hULsFVwRNhyvBCJDq6vaokVYJ6yG9C3bMgSuf18VWaA&s",
  //                   "position": 4,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Industrial Starch Market Growth, Trends, and Forecast 2032 | Cargill, Archer Daniels Midland, Ingredion, Tate & Lyle",
  //                   "link": "https://www.openpr.com/news/3935049/industrial-starch-market-growth-trends-and-forecast-2032",
  //                   "snippet": "Press release - SkyQuest Technology Group - Industrial Starch Market Growth, Trends, and Forecast 2032 | Cargill, Archer Daniels Midland, Ingredion,...",
  //                   "date": "1 week ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXBX8JfuigX8ib-nIq_Hzc42tgEtaXQO3Wp9fGgujJV9MygBwo9pGY3OMIzw&s",
  //                   "position": 5,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Food Texture Market Size to Surpass USD 27.62 Billion by 2034",
  //                   "link": "https://www.precedenceresearch.com/food-texture-market",
  //                   "snippet": "The global food texture market size was valued at USD 15.54 billion in 2024 and is expected to hit around USD 27.62 billion by 2034, growing at a CAGR of...",
  //                   "date": "3 weeks ago",
  //                   "source": "Precedence Research",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLUcg5_Ws5oJw6ABnOCnBOv7Lt9zUqZM3H8yhWNsUUAkWh-_Zlb0N8FbYBQ&s",
  //                   "position": 6,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Annatto Food Colors Market Size & Share, Forecasts 2024-2032",
  //                   "link": "https://www.gminsights.com/industry-analysis/annatto-food-colors-market",
  //                   "snippet": "The annatto food colors market size exceeded USD 210.4 million in 2023 and is expected to observe around 5.9% CAGR during 2024 to 2032, driven by the rising...",
  //                   "date": "7 months ago",
  //                   "source": "Global Market Insights Inc.",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPXStcH_zmtowMB4P3tv6ZsR2NKzrXMd4utgBG1HipkyBPJ4LORUOIvHVM1g&s",
  //                   "position": 7,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Food Emulsifiers Market Size to Hit USD 5.67 Billion by 2033 | Straits Research",
  //                   "link": "https://www.globenewswire.com/news-release/2024/11/06/2975829/0/en/Food-Emulsifiers-Market-Size-to-Hit-USD-5-67-Billion-by-2033-Straits-Research.html",
  //                   "snippet": "Food Emulsifiers Market Size, Share & Trends Analysis Report By Type (Mono, Diglycerides, and Derivatives, Lecithin, Sorbitan esters, Stearoyl lactylates,.",
  //                   "date": "4 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQFJCIJXLQrh1Dd4KlmT2B99nx_yIpAsBrChVCyQErligEM_8mp483RdREL&s",
  //                   "position": 8,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Global Food Coating Ingredients Market to Reach USD 10.58 Billion by 2035, Driven by Rising Demand for Enhanced Food Appearance and Shelf Life | Future Market Insights Inc.",
  //                   "link": "https://finance.yahoo.com/news/global-food-coating-ingredients-market-143000102.html",
  //                   "snippet": "The global food coating ingredients market is set for steady growth, with sales rising at a 6.7% CAGR from 2025 to 2035. Driven by globalization, evolving...",
  //                   "date": "1 month ago",
  //                   "source": "Yahoo Finance",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmih1t3YtUweAYpg6USnO0XQt6ZTUX1n4HP55tWxahKGQPQMSA6Rn13omjcA&s",
  //                   "position": 9,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Food Enzymes Market to grow by USD 1.04 Billion from 2025-2029, driven by rising demand from beverage industry, Report on AI's role in market transformation - Technavio",
  //                   "link": "https://www.prnewswire.com/news-releases/food-enzymes-market-to-grow-by-usd-1-04-billion-from-2025-2029--driven-by-rising-demand-from-beverage-industry-report-on-ais-role-in-market-transformation---technavio-302362897.html",
  //                   "snippet": "PRNewswire/ -- Report with market evolution powered by AI - The global food enzymes market size is estimated to grow by USD 1.04 billion from 2025-2029,...",
  //                   "date": "2 months ago",
  //                   "source": "PR Newswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSrN0GDtVURc9Xi4HKEp3zNPdpx8_W55P54F1Q02kMbMa-td8GG-XhFw2JHbQ&s",
  //                   "position": 10,
  //                   "query_key": "market_dynamics"
  //               },
  //               {
  //                   "title": "Modified Potato Starch Market: A Comprehensive Overview",
  //                   "link": "https://www.openpr.com/news/3848678/modified-potato-starch-market-a-comprehensive-overview",
  //                   "snippet": "The modified potato starch market is expected to reach USD 352.06 million by 2029, at a CAGR of 4.00% during the forecast period of 2022 to 2029.",
  //                   "date": "1 month ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSv9UxFP1_rsQ-llnzy5VHvGwz-xYSwHHikK_zwr_WK0cWkCugaKXza3ui7yA&s",
  //                   "position": 4,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Cargill Inaugurates New Corn Milling Plant to Meet Growing Demand for Safe and High-Quality Food Solutions",
  //                   "link": "http://webwire.com/ViewPressRel.asp?aId=335515",
  //                   "snippet": "Catering to the growing demand from India's confectionery, infant formula, and dairy sectors, Cargill inaugurated a new corn milling plant in Gwalior,...",
  //                   "date": "3 weeks ago",
  //                   "source": "WebWire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfgCWKq8kQ7MFQlqDSc49dj4E8GSpXbgLywkwvcrYgjvSXBmn9dwG05UyIfA&s",
  //                   "position": 7,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Cargill unveils major Indian investment with corn milling plant for confectionery",
  //                   "link": "https://www.confectioneryproduction.com/news/51903/cargill-unveils-major-indian-investment-with-corn-milling-plant-for-confectionery/",
  //                   "snippet": "Growing demand for confectionery and other food segments has seen Cargill inaugurate its latest Indian corn million plant, based in Gwalior, Madhya Pradesh,...",
  //                   "date": "3 weeks ago",
  //                   "source": "Confectionery Production",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRE1A8wKUpeKbUwlC90TLfUofixRwSp404dJKHL0ykllR83f7togKTGAx6dFQ&s",
  //                   "position": 8,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Protein Industries Canada Launches $24.5 Million Plant-Based Food Development Project",
  //                   "link": "https://vegconomist.com/investments-finance/protein-industries-canada-launches-24-5-million-plant-based-food-development-project/",
  //                   "snippet": "The $24.5 million project seeks to enhance Canadian companies' competitiveness by developing new ingredients and food products, improving process efficiencies.",
  //                   "date": "9 months ago",
  //                   "source": "vegconomist",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcweeqUAn6Mb_85XL1w1BJYPegOlq4GIKFl1afHCccAnRW98Xyd9__eH4aZA&s",
  //                   "position": 9,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Asia Pacific Cassava Starch Market Eying Valuation of USD 3,357.0 Million By 2032 | Astute Analytica",
  //                   "link": "https://www.globenewswire.com/news-release/2024/07/15/2913279/0/en/Asia-Pacific-Cassava-Starch-Market-Eying-Valuation-of-USD-3-357-0-Million-By-2032-Astute-Analytica.html",
  //                   "snippet": "The Asia Pacific cassava starch market is poised for robust growth, driven by increasing demand in the food, pharmaceutical, and textile industries....",
  //                   "date": "8 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4R6BFdZgVU37S4RSj6SsHpEqX-PeHftxQL4Hjuxve-yKEvs7EZz5kvk_ZUg&s",
  //                   "position": 10,
  //                   "query_key": "production"
  //               },
  //               {
  //                   "title": "Clean Label Food Ingredients Market Size, Share | CAGR of 6.5%",
  //                   "link": "https://market.us/report/clean-label-food-ingredients-market/",
  //                   "snippet": "Natural flavors lead ingredient preferences, accounting for 23.60% market penetration globally. In 2024, Natural Flavors held a dominant market position in...",
  //                   "date": "5 days ago",
  //                   "source": "Market.us",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ68xdVkgzuZPVY0kERsMqfXDasooqQvW6zHMjZQYBic-EDg9gXtqKAkXLo2A&s",
  //                   "position": 4,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Potato Starch Market Evaluation: Regional Outlook, Company Share Analysis, and Future Trends",
  //                   "link": "https://www.openpr.com/news/3951504/potato-starch-market-evaluation-regional-outlook-company",
  //                   "snippet": "02 April 2025, Metatech Insights - The Global Research Report Provides a Detailed Analysis of Potato Starch Market, Based on Competitive Intensity and How...",
  //                   "date": "6 hours ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQl9gSmXrTEjuVUAFCBDnLLk4MRvMbdqpoKO3RcQWuoeE9uW8deZ6wg3w2Ewg&s",
  //                   "position": 7,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Cargill inaugurates corn milling plant in Madhya Pradesh",
  //                   "link": "https://nuffoodsspectrum.in/2025/03/17/cargill-inaugurates-corn-milling-plant-in-madhya-pradesh.html",
  //                   "snippet": "The plant will produce starch derivatives to serve the confectionery, infant formula and dairy industries. Catering to the growing demand from India's...",
  //                   "date": "2 weeks ago",
  //                   "source": "FFOODS Spectrum",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUI2ivoXND1y1mdeYZ5SPnsAj4EvduLUfhHjI5LfyC7HqxJ8yGkIaz6OMmXg&s",
  //                   "position": 8,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Global Demand for Clean Label Starch Market is Expected to Progress to Reach US$ 2.5 Bn by 2031",
  //                   "link": "https://www.newstrail.com/global-demand-for-clean-label-starch-market-is-expected-to-progress-to-reach-us-2-5-bn-by-2031/",
  //                   "snippet": "The clean label starch market has been experiencing steady growth due to the increasing demand for natural, organic, and minimally processed food...",
  //                   "date": "1 month ago",
  //                   "source": "Newstrail",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5IpAXXdYKkQGM2Ah0ESLNLGc-MyPC_SJjKkSc9zti118lpc5hwDahXMf4YQ&s",
  //                   "position": 9,
  //                   "query_key": "supply_chain"
  //               },
  //               {
  //                   "title": "Consumer Demand for Plant-Based Foods is Surging After a “Lackluster” Year, Amid Protein Supply Challenges",
  //                   "link": "https://vegconomist.com/market-and-trends/demand-plant-based-foods-surging-protein-supply-challenges/",
  //                   "snippet": "Mintec by Expana, a global price reporting agency and market intelligence company, has released its Plant-Based Protein \"Monthly Market Insight,\" revealing.",
  //                   "date": "4 months ago",
  //                   "source": "vegconomist",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSU4ILxqKRyTarEGzME11prXM20Zudp87dSPBNGJG1RlhaqsiPiwpJD789TvA&s",
  //                   "position": 3,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Rock Candy Market Predicted to Expand to USD 907.2 Million by 2033 | Persistence Market Research Report",
  //                   "link": "https://www.openpr.com/news/3951933/rock-candy-market-predicted-to-expand-to-usd-907-2-million-by-2033",
  //                   "snippet": "Rock candy, a classic sweet treat beloved by many, continues to hold a significant place in the global confectionery market. Known for its crystalline...",
  //                   "date": "4 hours ago",
  //                   "source": "openPR.com",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCIBnotAnrbl2RTLss35UWAbCal_CZv5OfZwPZHmzr66LgSK2TVKJzlQqIMQ&s",
  //                   "position": 4,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Flour Market Size, Share, Trends & Analysis, 2033",
  //                   "link": "https://www.marketdataforecast.com/market-reports/flour-market",
  //                   "snippet": "The global flour market size was calculated to be USD 284.85 billion in 2024 and is anticipated to be worth USD 413.57 billion by 2033 from USD 296.90 billion...",
  //                   "date": "2 months ago",
  //                   "source": "Market Data Forecast",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRRcjN6gtYuk-RH0sZ0WAEdfXy4-VceOBK8tlOdQMoY8bkqBZeZu-onnbetQ&s",
  //                   "position": 6,
  //                   "query_key": "supply_demand"
  //               },
  //               {
  //                   "title": "Axiom Foods Expands Production of “Better-Tasting” Pea Protein to Address Supply Gaps and High Prices in the US",
  //                   "link": "https://vegconomist.com/ingredients/axiom-foods-expands-production-pea-protein/",
  //                   "snippet": "The pea protein is now produced at Axiom Foods' facilities in North America using local ingredients and the company's patented process.",
  //                   "date": "4 months ago",
  //                   "source": "vegconomist",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCKumz0huelNH86nf-gYTKY6AUaNiUpvIFEYUUW5M5wz8D5EOiWh4l78RkCA&s",
  //                   "position": 4,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Dextrin Market to Reach $4 Billion by 2032--Exclusive Report by Meticulous Research®",
  //                   "link": "https://www.prnewswire.co.uk/news-releases/dextrin-market-to-reach-4-billion-by-2032exclusive-report-by-meticulous-research-302399712.html",
  //                   "snippet": "PRNewswire/ -- According to a new market research report titled, 'Dextrin Market Size, Share, Forecast, & Trends Analysis by Type (Maltodextrin,...",
  //                   "date": "3 weeks ago",
  //                   "source": "PR Newswire UK",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcST8xruJ8iA9WBiHaiVC8kA_zKguoip7BGL9hk68Y2NAg&s",
  //                   "position": 7,
  //                   "query_key": "pricing"
  //               },
  //               {
  //                   "title": "Global Whey Protein Concentrate (WPC) Market Size To Worth USD 16.53 Billion By 2033 | CAGR of 10.57%",
  //                   "link": "https://www.globenewswire.com/news-release/2024/08/16/2931350/0/en/Global-Whey-Protein-Concentrate-WPC-Market-Size-To-Worth-USD-16-53-Billion-By-2033-CAGR-of-10-57.html",
  //                   "snippet": "The Global Whey Protein Concentrate (WPC) Market Size is to Grow from USD 6.05 Billion in 2023 to USD 16.53 Billion by 2033, at a Compound Annual Growth Rate (...",
  //                   "date": "7 months ago",
  //                   "source": "GlobeNewswire",
  //                   "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsHPxTxcuIdaA0nG0D5ZmYMBEHXGcyZ5qy1RT7fJiHYZj9X2Wo48R_9fLs2g&s",
  //                   "position": 8,
  //                   "query_key": "pricing"
  //               }
  //           ]
  //       }
  //   }
  // }

  // const indiSummaries={
  //   "Sweeteners": {
  //       "Sweeteners": {
  //           "https://www.chemanalyst.com/NewsAndDeals/NewsDetails/aspartame-prices-are-likely-to-rise-steadily-across-north-america-in-september-30326": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2025/03/13/3042109/0/en/North-America-Sugar-Free-Chewing-Gum-Report-2025-Market-Projected-to-Reach-US-3-53-Billion-by-2033.html": {
  //               "summary": [
  //                   "Rising demand for sugar-free gums with natural sweeteners like xylitol impacts sweetener sourcing in North America.",
  //                   "Digital platforms boost sugar-free gum distribution, increasing sweetener supply chain complexity."
  //               ]
  //           },
  //           "https://www.prnewswire.com/news-releases/artificial-sweeteners-market-set-to-soar-to-usd-22-billion-by-2031-driven-by-rising-health-trends-market-research-intellect-302253104.html": {
  //               "summary": [
  //                   "North America's sweetener market driven by health trends, with demand for low-calorie products rising.",
  //                   "Key players like Cargill and Tate & Lyle influence North American market dynamics."
  //               ]
  //           },
  //           "https://www.confectioneryproduction.com/news/49800/artificial-sweetener-market-forecast-for-major-growth-to-22-billion-by-2031/": {
  //               "summary": [
  //                   "North America leads in artificial sweetener market share, driven by health-conscious consumer demand.",
  //                   "Technological advancements enhance artificial sweetener production, fueling growth and innovation in North America."
  //               ]
  //           },
  //           "https://www.news.market.us/confectionery-statistics/": {
  //               "summary": [
  //                   "North American demand for low-sugar sweeteners rises, driven by health-conscious trends.",
  //                   "Sweetener innovation focuses on plant-based and organic options to meet consumer preferences."
  //               ]
  //           },
  //           "https://www.investopedia.com/rfk-s-war-on-corn-syrup-8762408": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.bloomberg.com/news/articles/2024-06-08/us-sugar-tariffs-make-canada-more-attractive-place-to-manufacture-candy": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/04/10/2861166/0/en/Sucralose-Market-to-Reach-USD-6-25-Billion-by-2033-Emergence-of-Functional-and-Fortified-Foods-to-Propel-Growth.html": {
  //               "summary": [
  //                   "North America's sucralose market to grow rapidly, driven by demand for low-calorie products and robust regulatory frameworks.",
  //                   "Liquid sucralose segment expected to expand, offering versatile applications in beverages and pharmaceuticals."
  //               ]
  //           },
  //           "https://www.prnewswire.com/news-releases/monk-fruit-sweeteners-market-to-reach-147-2-million-by-2032---exclusive-report-by-meticulous-research-302386060.html": {
  //               "summary": [
  //                   "Monk fruit sweeteners in North America poised for growth, driven by health trends and demand for organic products.",
  //                   "Solid form dominates due to ease of use and storage; B2B channels lead distribution."
  //               ]
  //           },
  //           "https://www.confectioneryproduction.com/news/51243/barry-callebaut-posts-quarterly-sales-decline-amid-ongoing-cocoa-price-surge/": {
  //               "summary": [
  //                   "Cocoa price surge impacts sweetener sourcing in North America, delaying orders and affecting supply chain stability.",
  //                   "SKU rationalization in North America limits sweetener availability, challenging sourcing strategies amid volatile market conditions."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/11/01/2973233/28124/en/Alternative-Sweeteners-Industry-Analysis-Trends-Developments-and-Opportunities-to-2029-Rising-Demand-for-Natural-Ingredients-Fuels-Growth-of-Local-Vendors-Intensifying-Global-Marke.html": {
  //               "summary": [
  //                   "North America's sweetener market grows due to health trends, increasing demand for low-calorie sugar substitutes.",
  //                   "High fructose corn syrup remains dominant due to solubility and favorable tariffs, impacting sourcing strategies."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/09/04/2940701/28124/en/Artificial-Sweetener-Market-to-Surge-to-US-10-30-Billion-by-2032-2024-Industry-Report.html": {
  //               "summary": [
  //                   "North America's sweetener market leads with obesity-driven demand, regulatory pushes, and R&D investments.",
  //                   "Artificial sweetener adoption rises due to diabetes prevalence and health-conscious consumer trends."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2025/02/11/3024419/0/en/Latest-Global-Sugar-Substitute-Market-Size-Share-Worth-USD-12-458-9-Million-by-2034-at-a-5-28-CAGR-Custom-Market-Insights-Analysis-Outlook-Leaders-Report-Trends-Forecast-Segmentati.html": {
  //               "summary": [
  //                   "North America's sweetener market growth driven by FDA approvals and increased diabetes prevalence.",
  //                   "High-intensity sweeteners gain traction due to rising health consciousness and chronic disease management."
  //               ]
  //           },
  //           "https://manufacturingdigital.com/articles/cargill-facility": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3938397/palm-sugar-market-set-to-reach-us-2-850-6-mn-by-2033-as-natural": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.accessnewswire.com/newsroom/en/food-and-beverage-products/invert-sugar-market-to-reach-new-heights-with-increasing-demand-from-food-913815": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/09/17/2947574/0/en/Sugar-Substitutes-Market-Surges-to-USD-25-4-Billion-by-2031-Propelled-by-4-42-CAGR-Verified-Market-Research.html": {
  //               "summary": [
  //                   "North America's demand for natural sweeteners grows, driven by health trends, offering opportunities for suppliers.",
  //                   "Regulatory challenges and raw material cost volatility impact sweetener sourcing strategies in North America."
  //               ]
  //           },
  //           "https://www.foodincanada.com/features/rising-demand-for-sugar-reduction-opportunities-and-obstacles-for-the-industry/": {
  //               "summary": [
  //                   "Rising demand for low/no sugar products in North America boosts alternative sweetener market.",
  //                   "Stevia solutions gain traction; balancing cost, taste, and functionality remains key for sweetener strategy."
  //               ]
  //           },
  //           "https://www.confectioneryproduction.com/news/52241/strategic-investment-enhances-dohlers-north-american-operations/": {
  //               "summary": [
  //                   "Döhler North America's acquisition of Premier Juices enhances sweetener sourcing with expanded natural fruit-based offerings.",
  //                   "Strategic operations in Delaware boost supply chain efficiency, impacting sweetener distribution across North America."
  //               ]
  //           },
  //           "https://www.snackandbakery.com/articles/113363-barry-callebaut-announces-us-government-relations-lead": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.greenqueen.com.hk/voyage-foods-cargill-cocoa-free-chocolate-nut-spreads/": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.confectioneryproduction.com/news/51539/hershey-record-upward-growth-across-us-and-global-sales-with-annual-results/": {
  //               "summary": [
  //                   "Hershey's Q4 2024 performance driven by favorable pricing and shipping conditions impacts sweetener sourcing strategy.",
  //                   "Expected cocoa price surge in 2025 may pressure sweetener procurement costs in North America."
  //               ]
  //           },
  //           "https://finance.yahoo.com/news/tagatose-market-size-worth-294-030000183.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.prnewswire.com/news-releases/industrial-granulated-sugar-market-to-reach-usd-50-billion-by-2031-driven-by-5-cagr-and-surging-demand-across-food-pharmaceutical-and-emerging-market---market-research-intellect-302299886.html": {
  //               "summary": [
  //                   "North America's shift to low-calorie sweeteners impacts sugar demand.",
  //                   "Emerging markets drive granulated sugar growth, affecting sourcing strategies."
  //               ]
  //           }
  //       },
  //       "Syrup": {
  //           "https://www.globenewswire.com/news-release/2025/02/06/3022131/0/en/Flavored-Syrup-Market-to-Reach-US-89-48-Billion-by-2034-Expanding-at-5-2-CAGR-Fact-MR-Report.html": {
  //               "summary": [
  //                   "North America's syrup market thrives due to mixology trends and diverse syrup applications in beverages.",
  //                   "East Asia poised to surpass North America in syrup sales, driven by beverage industry innovations."
  //               ]
  //           },
  //           "https://www.gminsights.com/industry-analysis/rice-syrup-market": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.bbc.com/news/articles/cn47zg3xgxxo": {
  //               "summary": [
  //                   "Syrup from cocoa fruit pulp offers a sustainable sugar alternative, enhancing chocolate flavor while reducing waste.",
  //                   "North American producers can leverage this innovation to meet rising demand for eco-friendly, premium chocolate."
  //               ]
  //           },
  //           "https://www.foodbusinessnews.net/articles/27654-cocoa-prices-impacting-hersheys-2025-forecast": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.accessnewswire.com/newsroom/en/food-and-beverage-products/invert-sugar-market-to-reach-new-heights-with-increasing-demand-from-food-913815": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/11/01/2973233/28124/en/Alternative-Sweeteners-Industry-Analysis-Trends-Developments-and-Opportunities-to-2029-Rising-Demand-for-Natural-Ingredients-Fuels-Growth-of-Local-Vendors-Intensifying-Global-Marke.html": {
  //               "summary": [
  //                   "North America's demand for low-calorie syrups rises due to health trends.",
  //                   "High fructose corn syrup market grows with favorable tariffs and food sector expansion."
  //               ]
  //           },
  //           "https://finance.yahoo.com/news/global-food-coating-ingredients-market-143000102.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3909202/maple-syrup-market-to-expand-annually-by-6-4-from-2025-to-2032": {
  //               "summary": [
  //                   "Maple syrup demand surges in North America, driven by health-conscious consumers seeking natural sweeteners.",
  //                   "Sourcing challenges arise from fluctuating climate conditions impacting maple syrup production and supply consistency."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/07/15/2913286/0/en/Global-Popping-Candy-Market-Size-To-Worth-USD-3-901-73-Million-By-2033-CAGR-of-4-15.html": {
  //               "summary": [
  //                   "North America's syrup demand surges, driven by rising confectionery market growth.",
  //                   "Compliance with food safety regulations challenges syrup market expansion in North America."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3952189/chocolate-milk-market-size-and-forecasts-2021-2031-global": {
  //               "summary": [
  //                   "Syrup demand in North America is projected to rise, driven by increased chocolate milk consumption.",
  //                   "Regional syrup sourcing strategies must adapt to evolving consumer preferences and market trends in flavored milk products."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/11/04/2974178/0/en/Glucose-Fructose-Syrup-Market-Poised-for-Growth-Driven-by-Diverse-Applications-in-Divers-Industry-Future-Market-Insights-Inc.html": {
  //               "summary": [
  //                   "North America's glucose-fructose syrup market to rise 23.5% by 2034, driven by health benefits and diverse applications.",
  //                   "Major players like Cargill and ADM focus on expanding syrup applications to enhance competitiveness."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3948818/agave-syrup-market-anticipated-to-reach-us-1-021-5-mn-by-2032": {
  //               "summary": [
  //                   "North American syrup demand surges, creating opportunities for strategic sourcing partnerships.",
  //                   "Rising sugar prices impact syrup production costs, necessitating cost-effective sourcing solutions."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2025/02/26/3032805/28124/en/2025-Analysis-of-the-World-Market-for-Fillings-and-Toppings-by-Type-Flavour-Form-Application-and-Region-Includes-Growth-Forecasts-to-2029-and-2034.html": {
  //               "summary": [
  //                   "Syrup demand driven by health trends and flavor exploration, impacting sourcing priorities in North America.",
  //                   "E-commerce growth boosts syrup market, necessitating strategic sourcing adjustments for online channels."
  //               ]
  //           },
  //           "https://www.investopedia.com/rfk-s-war-on-corn-syrup-8762408": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://civileats.com/2025/03/05/branching-out-beyond-maple-syrup/": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.bloomberg.com/news/articles/2024-05-03/hershey-hsy-sales-get-a-boost-from-high-prices-cocoa-rally": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.bbc.com/news/articles/cx2qpngxgp4o": {
  //               "summary": [
  //                   "US bans red dye 3 in syrups by 2027 due to cancer links.",
  //                   "Syrup manufacturers must reformulate without red dye 3, impacting sourcing strategies."
  //               ]
  //           },
  //           "https://www.thedailymeal.com/1796895/costco-groceries-going-up-price/": {
  //               "summary": [
  //                   "Canadian maple syrup tariffs may raise Costco prices by 25%, impacting North American syrup sourcing.",
  //                   "Increased syrup costs could affect consumer demand and sourcing strategies for North American retailers."
  //               ]
  //           },
  //           "https://www.foodincanada.com/food-business/valeo-foods-group-acquires-appalaches-nature-157944/": {
  //               "summary": [
  //                   "Valeo Foods expands North American syrup footprint with Appalaches Nature acquisition, boosting production capacity.",
  //                   "Integration with Bernard & Fils enhances synergy, supporting expansion in the syrup market."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/08/16/2931350/0/en/Global-Whey-Protein-Concentrate-WPC-Market-Size-To-Worth-USD-16-53-Billion-By-2033-CAGR-of-10-57.html": {
  //               "summary": [
  //                   "North America's syrup sourcing strategy should leverage WPC's rising demand in health drinks.",
  //                   "WPC 80% dominance suggests opportunity for syrup integration in sports nutrition products."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2025/02/19/3028824/0/en/Gluten-Free-Sugar-Syrup-Market-Size-is-Projected-to-Reach-USD-5-98-billion-by-2033-Growing-at-a-CAGR-of-6-3-Straits-Research.html": {
  //               "summary": [
  //                   "Rising gluten-free syrup demand in North America driven by health trends, impacting sourcing strategies.",
  //                   "Coca-Cola and PepsiCo explore gluten-free syrup options, influencing market dynamics."
  //               ]
  //           },
  //           "https://investigatemidwest.org/2025/03/26/these-crop-ag-producers-are-repeatedly-cited-for-child-labor-violations/": {
  //               "summary": [
  //                   "Child labor violations in syrup-related agriculture sectors impact sourcing strategies.",
  //                   "Increased scrutiny and fines on syrup production may affect supply chain compliance."
  //               ]
  //           },
  //           "https://sentientmedia.org/farmers-feeding-candy-to-animals/": {
  //               "summary": [
  //                   "Candy waste used as animal feed raises sustainability concerns, impacting syrup sourcing strategies.",
  //                   "High fructose corn syrup surplus fuels candy overproduction, affecting North American syrup market dynamics."
  //               ]
  //           },
  //           "https://market.us/report/global-enzymes-market/": {
  //               "summary": [
  //                   "North America's syrup industry sees growth via enzyme use, enhancing production efficiency and meeting health-conscious consumer demand.",
  //                   "Microbial enzymes dominate syrup production, offering cost-effective, stable, and eco-friendly solutions for North American markets."
  //               ]
  //           }
  //       },
  //       "Polyols": {
  //           "https://www.globenewswire.com/news-release/2025/03/11/3040731/0/en/Polyols-Market-to-Reach-USD-57-55-Billion-by-2032-Driven-by-Rising-Demand-for-High-Performance-Polyurethane-Foams-SNS-Insider.html": {
  //               "summary": [
  //                   "North America's Polyols market growth driven by health-conscious consumer demand for low-calorie products.",
  //                   "Technological advancements in Polyol formulations enhance sourcing strategies for diverse industry applications."
  //               ]
  //           }
  //       },
  //       "Starch": {
  //           "https://finance.yahoo.com/news/global-confectionery-market-size-worth-073000511.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/07/15/2913286/0/en/Global-Popping-Candy-Market-Size-To-Worth-USD-3-901-73-Million-By-2033-CAGR-of-4-15.html": {
  //               "summary": [
  //                   "North America leads starch market, driven by major confectionery brands and economic growth.",
  //                   "Compliance with food safety regulations challenges starch manufacturers, impacting market expansion."
  //               ]
  //           },
  //           "https://www.prnewswire.com/news-releases/clean-label-starch-market-to-reach-usd-2-6-billion-by-2032--driven-by-rising-demand-for-transparency-and-natural-ingredients--credence-research-inc-302330605.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.alliedmarketresearch.com/egg-replacement-ingredient-market-A239380": {
  //               "summary": [
  //                   "Starch-based egg replacements gain traction in North America amid rising plant-based diets.",
  //                   "Sourcing strategies adapt as starch becomes key in sustainable egg alternatives."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3935049/industrial-starch-market-growth-trends-and-forecast-2032": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.precedenceresearch.com/food-texture-market": {
  //               "summary": [
  //                   "Starch segment in North America sees rapid growth, driven by demand for plant-based, gluten-free products leveraging starch's multifunctional properties.",
  //                   "Rising starch application in dairy, bakery, and ready-to-eat meals enhances texture, aligning with clean-label trends in North America."
  //               ]
  //           },
  //           "https://www.gminsights.com/industry-analysis/annatto-food-colors-market": {
  //               "summary": [
  //                   "North America's starch market sees 6.1% CAGR, driven by demand for natural, clean-label products.",
  //                   "Advanced food processing and robust supply chains enhance annatto's market leadership in North America."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/11/06/2975829/0/en/Food-Emulsifiers-Market-Size-to-Hit-USD-5-67-Billion-by-2033-Straits-Research.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://finance.yahoo.com/news/global-food-coating-ingredients-market-143000102.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.prnewswire.com/news-releases/food-enzymes-market-to-grow-by-usd-1-04-billion-from-2025-2029--driven-by-rising-demand-from-beverage-industry-report-on-ais-role-in-market-transformation---technavio-302362897.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3848678/modified-potato-starch-market-a-comprehensive-overview": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "http://webwire.com/ViewPressRel.asp?aId=335515": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.confectioneryproduction.com/news/51903/cargill-unveils-major-indian-investment-with-corn-milling-plant-for-confectionery/": {
  //               "summary": [
  //                   "Cargill's new Indian plant boosts starch derivative supply, enhancing North American confectionery sourcing strategies.",
  //                   "Plant's 500-ton daily capacity, expandable to 1,000 tons, supports growing North American starch demand."
  //               ]
  //           },
  //           "https://vegconomist.com/investments-finance/protein-industries-canada-launches-24-5-million-plant-based-food-development-project/": {
  //               "summary": [
  //                   "BioNeutra to source domestic pea starch, reducing costs and enhancing efficiency.",
  //                   "Consortium explores new pea starch applications, expanding North American market opportunities."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/07/15/2913279/0/en/Asia-Pacific-Cassava-Starch-Market-Eying-Valuation-of-USD-3-357-0-Million-By-2032-Astute-Analytica.html": {
  //               "summary": [
  //                   "Cassava starch demand in North America rises with focus on modified starches, driven by food industry needs for natural, gluten-free additives.",
  //                   "Fragmented market offers opportunities for new entrants, emphasizing innovation in sustainable starch alternatives for processed foods."
  //               ]
  //           },
  //           "https://market.us/report/clean-label-food-ingredients-market/": {
  //               "summary": [
  //                   "North America's clean label starch market thrives, driven by transparency and health-conscious trends, capturing 49.4% market share in 2024.",
  //                   "Cargill leads with non-GMO starches, leveraging strategic investments to dominate North America's clean label market."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3951504/potato-starch-market-evaluation-regional-outlook-company": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://nuffoodsspectrum.in/2025/03/17/cargill-inaugurates-corn-milling-plant-in-madhya-pradesh.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.newstrail.com/global-demand-for-clean-label-starch-market-is-expected-to-progress-to-reach-us-2-5-bn-by-2031/": {
  //               "summary": [
  //                   "North America's clean label starch market grows due to consumer demand for natural ingredients, impacting sourcing strategies.",
  //                   "Key players like Cargill and Ingredion drive innovation and partnerships, enhancing supply chain capabilities for starch sourcing."
  //               ]
  //           },
  //           "https://vegconomist.com/market-and-trends/demand-plant-based-foods-surging-protein-supply-challenges/": {
  //               "summary": [
  //                   "Starch prices in Europe rise 14% YOY; North America faces stable prices but potential future hikes.",
  //                   "Adverse weather and reduced planting impact potato starch supply, affecting North American sourcing strategies."
  //               ]
  //           },
  //           "https://www.openpr.com/news/3951933/rock-candy-market-predicted-to-expand-to-usd-907-2-million-by-2033": {
  //               "summary": [
  //                   "North American starch demand rises due to increased food industry applications.",
  //                   "Sourcing strategies must adapt to potential supply chain disruptions in starch production."
  //               ]
  //           },
  //           "https://www.marketdataforecast.com/market-reports/flour-market": {
  //               "summary": [
  //                   "Cassava starch demand in North America rises by 3.1%, promoting local production and reducing reliance on wheat imports.",
  //                   "Climate change impacts wheat production, urging sustainable practices to stabilize North American starch supply chain."
  //               ]
  //           },
  //           "https://vegconomist.com/ingredients/axiom-foods-expands-production-pea-protein/": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.prnewswire.co.uk/news-releases/dextrin-market-to-reach-4-billion-by-2032exclusive-report-by-meticulous-research-302399712.html": {
  //               "summary": [
  //                   "Insights not available."
  //               ]
  //           },
  //           "https://www.globenewswire.com/news-release/2024/08/16/2931350/0/en/Global-Whey-Protein-Concentrate-WPC-Market-Size-To-Worth-USD-16-53-Billion-By-2033-CAGR-of-10-57.html": {
  //               "summary": [
  //                   "North American starch sourcing must consider rising whey protein demand, impacting availability and pricing.",
  //                   "WPC 80% dominance in fitness markets could shift starch-based product strategies."
  //               ]
  //           }
  //       }
  //   }
  // }

  // console.log("cat news are", categoryNews);
  // console.log("global summaries", globalSummaries);
  // console.log("topCategories", topCategories);
  // console.log('main category', Object.keys(topCategories[0])[0]);
  // console.log("topCategories type:", typeof topCategories);

  // console.log('filter', filteredResults);
  useEffect(() => {
    if (!selectedCategory && topCategories?.length > 0) {
      setSelectedCategory(topCategories[0]);
    }
  }, [topCategories, selectedCategory, setSelectedCategory]);

  // Add this separate useEffect to log category changes
  useEffect(() => {
    console.log("selected category is", selectedCategory);
    console.log("selected l3 is", selectedL3Category);
  }, [selectedCategory]);

  const handleTabChange = (_, newValue) => {
    // Make sure we're setting the category name, not the index
    const categoryName =
      topCategories[newValue]?.name || topCategories[newValue];
    setSelectedCategory(categoryName);
  };

  // console.log('global summaries', globalSummaries['Sweeteners']['Starch']);

  const LoadingGif = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
        width: "auto",
      }}
    >
      <img
        src={ailoader}
        alt="Loading..."
        style={{ width: "30px", height: "30px" }}
      />
    </Box>
  );

  const leftGridRef = useRef(null);
  const rightGridRef = useRef(null);

  useEffect(() => {
    const adjustHeight = () => {
      if (leftGridRef.current && rightGridRef.current) {
        const leftHeight = leftGridRef.current.clientHeight;
        const rightHeight = rightGridRef.current.clientHeight;

        if (rightHeight > leftHeight) {
          leftGridRef.current.style.height = `${rightHeight}px`;
        } else {
          leftGridRef.current.style.height = "auto";
        }
      }
    };

    adjustHeight();
    window.addEventListener("resize", adjustHeight);

    return () => window.removeEventListener("resize", adjustHeight);
  }, [selectedCategory]); // Re-run when selectedCategory changes

  // const sortedNews= []

  // console.log("client name", clientNames);
  // const { client_names } = clientNames;
  // const clientName = client_names[0]; // Directly access the first item

  const selectedCategoryName = selectedCategory;
  const categoryName = Object.keys(selectedCategoryName)[0];
  // Get the spend value from topContributors using selected category name
  const spendValue =
    topContributors[categoryName]?.[selectedL3Category]?.spend || "N/A";
  console.log("selectedL3Category is", selectedL3Category);
  console.log("spend value is", spendValue);
  const topc = topContributors[selectedCategoryName]?.topContributors || "N/A";

  const [number, restContent] = topc.split(";", 2);
  console.log("selectedCategoryName", selectedCategoryName);
  console.log("topctest", topCategories[0]);
  const costStruc =
    costStructure[selectedCategoryName]?.cost_structure || "N/A";
  console.log("costS is", costStruc);

  const catDict = categoryDict?.[categoryName]?.[selectedL3Category] || "N/A";
  const source = csSrc[selectedCategoryName]?.source || "N/A";

  const dandS = demandandSupply[selectedCategoryName]?.text || "N/A";

  const mSize = marketSize[selectedCategoryName] || "N/A";

  const [label, value] = mSize.split(":", 2);

  const topSup = topSuppliers?.[categoryName]?.[selectedL3Category] || "N/A";
  const topSupList = useMemo(() => {
    if (!topSup || topSup === "N/A") return [];
    const clean = (val) =>
      typeof val === "string" ? val.replace(/['"]/g, "") : String(val);
    if (Array.isArray(topSup)) return topSup.map(clean);
    if (typeof topSup === "string") return [clean(topSup)];
    if (typeof topSup === "object") {
      if (Array.isArray(topSup.Labels)) return topSup.Labels.map(clean);
      if (Array.isArray(topSup.labels)) return topSup.labels.map(clean);
      if (topSup.Labels?.Labels && Array.isArray(topSup.Labels.Labels)) {
        return topSup.Labels.Labels.map(clean);
      }
      const firstArray = Object.values(topSup).find((v) => Array.isArray(v));
      if (firstArray) return firstArray.map(clean);
      const firstString = Object.values(topSup).find(
        (v) => typeof v === "string"
      );
      if (firstString) return [clean(firstString)];
    }
    return [String(topSup)];
  }, [topSup]);
  const topSupText = useMemo(
    () => (topSupList.length ? topSupList.join(", ") : "N/A"),
    [topSupList]
  );
  const selectedCategoryNews =
    categoryNews?.[categoryName]?.[selectedL3Category] || [];

  console.log("news is", selectedCategoryNews);
  console.log(
    "indiSummaries",
    indiSummaries?.[categoryName]?.[selectedL3Category]
  );

  // console.log('testcat1', categoryName);
  // console.log('testcat2', selectedL3Category);
  //     console.log("selected category for news", globalSummaries?.[categoryName]?.[selectedL3Category]);
  // console.log(
  //   "global summary for selected category",
  //   globalSummaries?.[categoryName]?.[categoryName]?.[selectedL3Category]
  // );

  // const [globalSummary, setGlobalSummary] = useState({});
  // const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const { filename } = useFileContext();

  const parseRelativeDate = (dateStr) => {
    const now = new Date();

    // Handle "X week/month ago" format
    if (dateStr.includes("ago")) {
      const [value, unit] = dateStr.split(" ");
      const numValue = parseInt(value);

      if (unit.includes("week")) {
        return new Date(now - numValue * 7 * 24 * 60 * 60 * 1000);
      } else if (unit.includes("month")) {
        return new Date(now - numValue * 30 * 24 * 60 * 60 * 1000);
      }
    }

    // Handle "MMM DD, YYYY" format
    return new Date(dateStr);
  };

  const getTimeAgo = (date) => {
    const now = new Date();
    const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

    if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays !== 1 ? "s" : ""} ago`;
    } else if (diffInDays < 30) {
      const weeks = Math.floor(diffInDays / 7);
      return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    } else {
      const months = Math.floor(diffInDays / 30);
      return `${months} month${months !== 1 ? "s" : ""} ago`;
    }
  };
  const [cardHeight, setCardHeight] = useState(null);
  const newsContainerRef = useRef(null);
  const globalSummaryRef = useRef(null);

  useEffect(() => {
    if (newsContainerRef.current && globalSummaryRef.current) {
      // Get the last card in the news container
      const newsCards = newsContainerRef.current.querySelectorAll(".news-card");
      const lastCard = newsCards[newsCards.length - 1];

      if (lastCard) {
        // Calculate exact bottom position of last card
        const lastCardBottom = lastCard.getBoundingClientRect().bottom;
        const containerTop =
          newsContainerRef.current.getBoundingClientRect().top;
        const exactHeight = lastCardBottom - containerTop;

        setCardHeight(exactHeight);
      }
    }
  }, [selectedCategoryNews]);

  const tableHeaders = ["Metric", "Impact", "Outlook"]; // Define table headers

  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: "16px",
          gap: "16px",
          // marginTop: "10rem",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "4rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px", // Space between title and line
              flex: 1, // Takes up remaining space
            }}
          >
            <Typography
              style={{
                fontStyle: "Roboto",
                fontSize: "14px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
                whiteSpace: "nowrap", // Prevents text from wrapping
              }}
            >
              <b>Deep dive for top 3 categories</b>
            </Typography>

            {/* <Box
        sx={{
          height: "1px",
          backgroundColor: "#FFFFFF29",
          flex: 1, // Makes the line fill remaining space
        }}
      /> */}
          </Box>

          {/* Second level tabs (L3 categories) */}
          {Object.keys(topCategories[0]).length > 0 && (
            <Box className="category-selection" sx={{ margin: "2px" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {(() => {
                  const mainCategory = Object.keys(topCategories[0])[0];
                  const l3Categories = topCategories[0][mainCategory];

                  return (
                    <>
                      {/* Main category with radio button and dropdown arrow */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          borderBottom:
                            showSubcategories === true
                              ? "1px solid #FFFFFF1A"
                              : "none",
                          paddingBottom: "2px",
                        }}
                      >
                        <Box
                          onClick={() => setSelectedL3Category(mainCategory)}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            "&:hover": { opacity: 0.8 },
                          }}
                        >
                          <Radio
                            size="small"
                            checked={selectedL3Category === mainCategory}
                            sx={{
                              color: "#FFFFFFB2",
                              "&.Mui-checked": {
                                color: "#FF69B4",
                                fontSize: "12px",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: 500,
                              lineHeight: "20px",
                              color: "#FFFFFF",
                            }}
                          >
                            {mainCategory}
                          </Typography>
                        </Box>

                        {/* Arrow down button */}
                        <IconButton
                          onClick={() =>
                            setShowSubcategories(!showSubcategories)
                          }
                          size="small"
                          sx={{ color: "#FFFFFF" }}
                        >
                          {showSubcategories === false ? (
                            <ExpandMoreOutlined />
                          ) : (
                            <ExpandLessOutlined />
                          )}
                        </IconButton>
                      </Box>

                      {/* Subcategories (conditionally rendered) */}
                      {showSubcategories && (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            marginTop: "8px",
                          }}
                        >
                          {l3Categories.map((l3Category, index) => (
                            <Box
                              key={index}
                              onClick={() => setSelectedL3Category(l3Category)}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                "&:hover": { opacity: 0.8 },
                              }}
                            >
                              <Radio
                                size="small"
                                checked={selectedL3Category === l3Category}
                                sx={{
                                  color: "#FFFFFFB2",
                                  "&.Mui-checked": {
                                    color: "#FF69B4",
                                    fontSize: "12px",
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: 300,
                                  lineHeight: "15px",
                                  fontStyle: "Inter",
                                  color: "#FFFFFFB2",
                                }}
                              >
                                {l3Category}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </>
                  );
                })()}
              </Box>
            </Box>
          )}
        </Box>

        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          // sx={{ marginTop: "0.5rem" }}
        >
          {/* Left half - KPS and Insights */}
          <Grid
            className="pdf-section"
            item
            xs={12}
            md={12}
            sx={{
              width: "510px",
              marginRight: "0.25rem",
              marginLeft: "0.5rem",
              padding: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* <Box sx={{ mb: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "1rem",
                    display: "flex",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Toll
                    sx={{
                      mr: 0.5,
                      height: "15px",
                      width: "15px",
                      color: "#FFFFFFFF",
                    }}
                  />
                  <span
                    style={{
                      fontStyle: "Roboto",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "white",
                    }}
                  >
                    Spend
                  </span>
                </Typography>

                <Box
                  sx={{
                    height: "1px",
                    backgroundColor: "#FFFFFF29",
                    flex: 1,
                  }}
                />
              </Box>
            </Box> */}

            <Box sx={{ display: "flex" }}>
              <Box sx={{ width: "50%" }}>
                {/* Suppliers */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={{ marginBottom: "4px", fontSize: "1rem" }}>
                    <span
                      style={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#FFFFFF99",
                      }}
                    >
                      {selectedL3Category} spend & suppliers for the client
                    </span>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontStyle: "Roboto",
                      fontWeight: 500,
                      color: "white",
                      borderBottom: "1px solid #FFFFFF0F",
                      paddingBottom: "8px",
                    }}
                  >
                    {(() => {
                      const mainCategory = Object.keys(
                        topCategories[selectedMainCategoryIndex]
                      )[0];
                      const contributorsData =
                        topContributors[mainCategory]?.[selectedL3Category]
                          ?.topContributors;

                      if (!contributorsData || contributorsData === "N/A") {
                        return <Skeleton width="100%" />;
                      }

                      const [number, restContent] = contributorsData.split(
                        ";",
                        2
                      );
                      return (
                        <>
                          {spendValue} &mdash;
                          {number} suppliers &mdash;
                          {restContent && <span> {restContent}</span>}
                        </>
                      );
                    })()}
                  </Typography>
                </Box>

                {/* Cost Structure */}
                {/* Cost Structure */}
                <Box sx={{ mb: 2, borderBottom: "1px solid #FFFFFF0F" }}>
                  <Typography
                    color="#FFFFFF99"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "1rem",
                      marginBottom: "4px",
                    }}
                  >
                    <Toll
                      sx={{
                        mr: 0.25,
                        height: "15px",
                        width: "15px",
                        color: "#FFFFFF99",
                      }}
                    />
                    <span
                      style={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Cost structure
                    </span>
                  </Typography>

                  {(() => {
                    // Get the actual category name (Metal Tubes in this case)
                    const categoryName = Object.keys(selectedCategoryName)[0];
                    const costStructureData =
                      costStructure?.[categoryName]?.[selectedL3Category];
                    const sourceCitation =
                      csSrc?.[categoryName]?.[selectedL3Category];

                    console.log("csD is", costStructureData);
                    console.log("sourceCitation", sourceCitation);
                    console.log("categoryName", categoryName);

                    if (!costStructureData) {
                      return (
                        <>
                          <Skeleton width="100%" />
                          <Skeleton width="80%" />
                          <Skeleton width="90%" />
                        </>
                      );
                    }

                    return (
                      <>
                        <Typography
                          className="print-white"
                          sx={{
                            fontSize: "12px",
                            fontStyle: "Roboto",
                            fontWeight: 500,
                            color: "white",
                          }}
                        >
                          {costStructureData
                            .replace(/['"]/g, "")
                            .split("*")
                            .filter(Boolean)
                            .map((line, index) => (
                              <Box
                                key={index}
                                sx={{
                                  marginBottom: "4px",
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Typography
                                  component="span"
                                  sx={{
                                    marginRight: "8px",
                                    color: "#FFFFFF",
                                    fontSize: "10px",
                                    lineHeight: "20px",
                                  }}
                                >
                                  •
                                </Typography>
                                <Typography
                                  component="span"
                                  sx={{
                                    fontSize: "12px",
                                    fontStyle: "Roboto",
                                    color: "white",
                                    lineHeight: "20px",
                                  }}
                                >
                                  {line.trim()}
                                </Typography>
                              </Box>
                            ))}
                        </Typography>

                        {/* Pie Chart */}
                        {catDict !== "N/A" ? (
                          <PieChartComponent
                            data={Object.entries(catDict).map(
                              ([key, value]) => ({
                                label: key,
                                value: value,
                              })
                            )}
                            spendValue={spendValue}
                          />
                        ) : (
                          <>
                            <Skeleton
                              variant="circular"
                              width={200}
                              height={200}
                            />
                            <Skeleton width="75%" />
                          </>
                        )}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {" "}
                          {/* Parent container */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              border: "1px solid transparent",
                              borderRadius: "6px",
                              marginBottom: "8px",
                              padding: "2px",
                              alignItems: "center",
                              justifyContent: "center",
                              alignContent: "center",
                              width: "150px",
                            }}
                          >
                            <Typography
                              style={{
                                color: "white",
                                fontSize: "9px",
                                fontStyle: "Roboto",
                                fontWeight: 300,
                              }}
                            >
                              <i>Source:</i>
                            </Typography>
                            <MUITooltip title="source" arrow placement="right">
                              {/* <Chip
      label={sourceCitation}
      icon={
        <img
          src={sourceicon}
          alt="icon"
          style={{
            width: "9px",
            height: "9px",
          }}
        />
      }
      sx={{
        padding: "2px",
        height: "20px", 
        border: "1px solid",
        borderRadius: "900px",
        fontStyle: "italic",
        marginTop: "4px",
        fontSize: "9px",
        fontWeight: 300,
        color: "white",
        backgroundColor: "#FFFFFF1F",
        marginBottom: "8px",
        "& .MuiChip-icon": {
          color: "white",
        },
      }}
    /> */}
                              <Typography
                                sx={{
                                  color: "white",
                                  fontSize: "9px",
                                  fontStyle: "Roboto",
                                  fontWeight: 300,
                                }}
                              >
                                {sourceCitation}
                              </Typography>
                            </MUITooltip>
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </Box>
                {/* Alternate Suppliers */}
                <Box sx={{ mb: 1 }}>
                  <Typography
                    color="#FFFFFF99"
                    sx={{
                      fontSize: "1rem",
                      marginBottom: "4px",
                      display: "flex", // Added flex display
                      alignItems: "center", // Center items vertically
                    }}
                  >
                    <TbTopologyStar3
                      style={{
                        marginRight: "2px", // Adjusted margin for better spacing
                        height: "12px",
                        width: "12px",
                        color: "#FFFFFF99",
                      }}
                    />
                    <span
                      style={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      Alternate suppliers
                    </span>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "white",
                    }}
                  >
                    {topSupList.length ? (
                      <Box
                        component="ul"
                        sx={{
                          pl: 2,
                          m: 0,
                          color: "white",
                          listStyleType: "disc",
                        }}
                      >
                        {topSupList.map((item, idx) => (
                          <li key={idx}>
                            <Typography
                              component="span"
                              sx={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: "white",
                              }}
                            >
                              {item}
                            </Typography>
                          </li>
                        ))}
                      </Box>
                    ) : (
                      <>
                        <Skeleton width="100%" />
                        <Skeleton width="75%" />
                      </>
                    )}
                  </Typography>
                  {topSupList.length ? (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      {" "}
                      {/* Parent container */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          border: "1px solid transparent",
                          borderRadius: "6px",
                          marginBottom: "8px",
                          padding: "2px",
                          alignItems: "center",
                          justifyContent: "center",
                          alignContent: "center",
                          width: "150px",
                          marginTop: "6px",
                        }}
                      >
                        <Typography
                          style={{
                            color: "white",
                            fontSize: "9px",
                            fontStyle: "Roboto",
                            fontWeight: 300,
                          }}
                        >
                          <i>Source:</i>
                        </Typography>
                        <MUITooltip title="source" arrow placement="right">
                          {/* <Chip
                  label={sourceCitation}
                  icon={
                    <img
                      src={sourceicon}
                      alt="icon"
                      style={{
                        width: "9px",
                        height: "9px",
                      }}
                    />
                  }
                  sx={{
                    padding: "2px",
                    height: "20px", 
                    border: "1px solid",
                    borderRadius: "900px",
                    fontStyle: "italic",
                    marginTop: "4px",
                    fontSize: "9px",
                    fontWeight: 300,
                    color: "white",
                    backgroundColor: "#FFFFFF1F",
                    marginBottom: "8px",
                    "& .MuiChip-icon": {
                      color: "white",
                    },
                  }}
                /> */}
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "9px",
                              fontStyle: "Roboto",
                              fontWeight: 300,
                            }}
                          >
                            Market sources
                          </Typography>
                        </MUITooltip>
                      </div>
                    </div>
                  ) : (
                    <Skeleton width="50%" height={24} />
                  )}
                </Box>
              </Box>
              {/* Vertical Divider */}
              <Box
                sx={{
                  width: "1px",
                  backgroundColor: "#FFFFFF29",
                  mx: 2,
                }}
              />

              {/* Right Section */}
              <Box
                sx={{
                  width: "50%",
                  pl: 2,
                }}
              >
                {porterForces && Object.keys(porterForces)?.length > 0 ? (
                  <PorterForces
                    porterForces={porterForces}
                    catandSpend={catandSpend}
                    marketImplications={marketImplications}
                    selectedL3Category={selectedL3Category}
                  />
                ) : (
                  <>
                    <Skeleton width="100%" />
                    <Skeleton width="75%" />
                  </>
                )}
              </Box>
            </Box>
          </Grid>
          {/* Right half - Summary of Latest Market Insights */}
          {/* Right half - Summary of Latest Market Insights */}
          <Grid
            className="pdf-section"
            item
            xs={12}
            md={12}
            sx={{
              // backgroundColor: "#FFFFFF0F",
              // border: "1px solid transparent",
              // width: "510px",
              // borderRadius: "10px",
              marginRight: "0.25rem",
              marginLeft: "0.5rem",
              padding: "10px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box display="flex" flexDirection="column">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
                flexWrap="wrap"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    flex: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontStyle: "Roboto",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "16.94px",
                      textAlign: "left",
                      color: "white",
                      marginBottom: { xs: "10px", sm: 0 },
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Campaign sx={{ mr: 0.5, verticalAlign: "middle" }} />{" "}
                    Latest market insights
                  </Typography>

                  <Box
                    sx={{
                      height: "1px",
                      backgroundColor: "#FFFFFF29",
                      flex: 1,
                    }}
                  />
                </Box>

                {selectedCategoryNews.length > 0 && (
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ marginLeft: "16px" }}
                  >
                    <Button
                      onClick={() => {
                        console.log("Read more clicked");
                        setShowNewsOverlay(true);
                      }}
                      sx={{
                        fontStyle: "Roboto",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "15px",
                        color: "#BE3FF5",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        textTransform: "none",
                      }}
                    >
                      Read more
                    </Button>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: 2,
                  width: "100%",
                }}
              >
                {/* Global Summary Section */}
                <Card
                  ref={globalSummaryRef}
                  sx={{
                    backgroundColor: "#FFFFFF0F",
                    border: "1px solid #FFFFFF0F",
                    borderRadius: "8px",
                    p: 2,
                    width: "50%",
                    gap: 2,
                    position: "relative",
                    height: cardHeight ? `${cardHeight}px` : "auto",
                    overflowY: cardHeight ? "auto" : "visible",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    // Hide scrollbar for IE, Edge and Firefox
                    msOverflowStyle: "none", // IE and Edge
                    scrollbarWidth: "none", // Firefox
                  }}
                >
                  <Typography
                    color="white"
                    mb={2}
                    style={{
                      fontStyle: "Roboto",
                      fontSize: "14px",
                      fontWeight: 600,
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={gs}
                      alt="Global Summary"
                      width="18px"
                      height="18px"
                      style={{ marginRight: "0.3rem" }}
                    />
                    Here are the key points from the latest market insights
                  </Typography>
                  <Box sx={{}}>
                    {Object.keys(globalSummaries || {}).length === 0 ? (
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        height="200px"
                      >
                        <LoadingGif />
                        <Typography
                          sx={{
                            fontStyle: "Roboto",
                            fontSize: "14px",
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          <i>Analyzing market insights...</i>
                        </Typography>
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Box
                          sx={{
                            border: "1px solid transparent",
                            borderRadius: "8px",
                            backgroundColor: "transparent",
                          }}
                        >
                          <TableContainer
                            sx={{ borderRadius: "8px", overflow: "hidden" }}
                          >
                            <Table
                              size="small"
                              sx={{
                                backgroundColor: "#FFFFFF0F",
                                borderRadius: "8px",
                              }}
                            >
                              {/* Table Header */}
                              <TableHead>
                                <TableRow sx={{ fontStyle: "Roboto" }}>
                                  {tableHeaders.map((header, index) => (
                                    <TableCell
                                      key={index}
                                      sx={{
                                        color: "white",
                                        fontStyle: "Roboto",
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        borderBottom: "1px solid #FFFFFF0F",
                                        backgroundColor: "#FFFFFF1F",
                                        textAlign: "right",
                                      }}
                                    >
                                      {header}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>

                              {/* Table Body */}
                              <TableBody sx={{ fontStyle: "Roboto" }}>
                                {[
                                  "Pricing",
                                  "Supply Trend",
                                  "Demand Trend",
                                ].map((category) => {
                                  const summaryData =
                                    globalSummaries?.[categoryName]?.[
                                      selectedL3Category
                                    ];

                                  // Skip if no data exists for this category
                                  if (
                                    !summaryData ||
                                    !summaryData[category] ||
                                    summaryData[category].length === 0
                                  )
                                    return null;

                                  return (
                                    <TableRow
                                      key={category}
                                      sx={{
                                        borderBottom: "1px solid #FFFFFF0F",
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        lineHeight: "20px",
                                        textAlign: "left",
                                        "& td, & th": {
                                          borderBottom: "none",
                                        },
                                      }}
                                    >
                                      {/* Metric */}
                                      <TableCell
                                        sx={{
                                          color: "white",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {category}
                                      </TableCell>

                                      {/* Impact */}
                                      <TableCell>
                                        {category === "Demand Trend" ? (
                                          summaryData["Demand Trend"][0]
                                            .Indicator === "I" ? (
                                            <TrendingUpSharp
                                              sx={{
                                                color: "#f44336",
                                                fontSize: "20px",
                                              }}
                                            /> // Red for 'I' (Demand)
                                          ) : summaryData["Demand Trend"][0]
                                              .Indicator === "D" ? (
                                            <TrendingDownSharp
                                              sx={{
                                                color: "#4caf50",
                                                fontSize: "20px",
                                              }}
                                            /> // Green for 'D' (Demand)
                                          ) : (
                                            <TrendingFlatSharp
                                              sx={{
                                                color: "#ff9800",
                                                fontSize: "20px",
                                              }}
                                            /> // Orange for 'N'
                                          )
                                        ) : category === "Supply Trend" ? (
                                          summaryData["Supply Trend"][0]
                                            .Indicator === "I" ? (
                                            <TrendingUpSharp
                                              sx={{
                                                color: "#4caf50",
                                                fontSize: "20px",
                                              }}
                                            /> // Green for 'I' (Supply)
                                          ) : summaryData["Supply Trend"][0]
                                              .Indicator === "D" ? (
                                            <TrendingDownSharp
                                              sx={{
                                                color: "#f44336",
                                                fontSize: "20px",
                                              }}
                                            /> // Red for 'D' (Supply)
                                          ) : (
                                            <TrendingFlatSharp
                                              sx={{
                                                color: "#ff9800",
                                                fontSize: "20px",
                                              }}
                                            /> // Orange for 'N'
                                          )
                                        ) : category === "Pricing" ? (
                                          summaryData["Pricing"][0]
                                            .Indicator === "I" ? (
                                            <TrendingUpSharp
                                              sx={{
                                                color: "#f44336",
                                                fontSize: "20px",
                                              }}
                                            /> // Red for 'I' (Price)
                                          ) : summaryData["Pricing"][0]
                                              .Indicator === "D" ? (
                                            <TrendingDownSharp
                                              sx={{
                                                color: "#4caf50",
                                                fontSize: "20px",
                                              }}
                                            /> // Green for 'D' (Price)
                                          ) : (
                                            <TrendingFlatSharp
                                              sx={{
                                                color: "#ff9800",
                                                fontSize: "20px",
                                              }}
                                            /> // Orange for 'N'
                                          )
                                        ) : null}
                                      </TableCell>

                                      {/* Outlook */}
                                      <TableCell
                                        sx={{
                                          color: "rgba(255, 255, 255, 0.7)",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {category === "Demand Trend" &&
                                          summaryData["Demand Trend"][0]
                                            ?.Reason}
                                        {category === "Supply Trend" &&
                                          summaryData["Supply Trend"][0]
                                            ?.Reason}
                                        {category === "Pricing" &&
                                          summaryData["Pricing"][0]?.Reason}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>

                        {/* Additional Market Information Section */}
                        <Box sx={{ mt: 2 }}>
                          {[
                            "Supply Chain Overview",
                            "Regulatory Environment",
                            "ESG",
                          ].map((category) => {
                            // Check if the category exists in the data
                            const summaryData =
                              globalSummaries?.[categoryName]?.[
                                selectedL3Category
                              ];
                            if (!summaryData || !summaryData[category])
                              return null;

                            const data = summaryData[category];

                            // Skip if no data exists for this category
                            if (
                              !data ||
                              (Array.isArray(data) && data.length === 0)
                            )
                              return null;

                            return (
                              <Box key={category} sx={{ mb: 2 }}>
                                <Typography
                                  color="white"
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 550,
                                    mb: 1,
                                  }}
                                >
                                  {category}
                                </Typography>
                                {/* Handle both array and string data formats */}
                                {Array.isArray(data) ? (
                                  data.map((item, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        color: "rgba(255, 255, 255, 0.7)",
                                      }}
                                    >
                                      •
                                      <Typography
                                        color="rgba(255, 255, 255, 0.7)"
                                        sx={{
                                          fontSize: "12px",
                                          ml: 1,
                                          mb: 0.5,
                                        }}
                                      >
                                        {item}
                                      </Typography>
                                    </div>
                                  ))
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      color: "rgba(255, 255, 255, 0.7)",
                                    }}
                                  >
                                    •
                                    <Typography
                                      color="rgba(255, 255, 255, 0.7)"
                                      sx={{
                                        fontSize: "12px",
                                        ml: 1,
                                        mb: 0.5,
                                      }}
                                    >
                                      {data}
                                    </Typography>
                                  </div>
                                )}
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Card>

                <Box
                  ref={newsContainerRef}
                  sx={{
                    // width: Object.keys(globalSummary || {}).length > 0 ? '60%' : '100%'
                    width: "100%",
                  }}
                >
                  {selectedCategoryNews.length > 0 ? (
                    <>
                      <div>
                        {selectedCategoryNews
                          .filter(
                            (newsItem, index, self) =>
                              index ===
                              self.findIndex(
                                (item) => item.title === newsItem.title
                              )
                          )
                          // .sort((a, b) => parseRelativeDate(b.date) - parseRelativeDate(a.date))
                          .sort((a, b) => {
                            const dateA = parseRelativeDate(a.date);
                            const dateB = parseRelativeDate(b.date);
                            return dateB - dateA;
                          })
                          .slice(0, 3)
                          .map((newsItem, index) => (
                            <div key={index} className="news-card">
                              <Card
                                // key={index}
                                sx={{
                                  mb: 2,
                                  display: "flex",
                                  backgroundColor: "transparent",
                                  boxShadow: "none",
                                  border: "1px solid rgba(255, 255, 255, 0.5)",
                                  borderRadius: "8px",
                                  width: "100%",
                                  // height: "120px",
                                  flexDirection: { xs: "column", sm: "row" },
                                  overflow: "hidden",
                                  position: "relative",
                                }}
                              >
                                <IconButton
                                  onClick={() =>
                                    window.open(newsItem.link, "_blank")
                                  }
                                  sx={{
                                    position: "absolute",
                                    top: 8,
                                    right: 8,
                                    color: "white",
                                    zIndex: 10,
                                    // border: '1px solid #BE3FF5',
                                    // borderRadius: '4px',
                                    background: "#FFFFFF0",
                                  }}
                                >
                                  <OpenInNew
                                    style={{
                                      marginRight: "0.3rem",
                                      height: "16px",
                                      width: "16px",
                                    }}
                                  />
                                </IconButton>
                                <CardMedia
                                  component="img"
                                  sx={{
                                    width: { xs: "100%", sm: "100px" },
                                    // height: { xs: "140px", sm: "140px" },
                                    objectFit: "cover",
                                  }}
                                  //   image={
                                  //     newsItem.imageUrl &&
                                  //     newsItem.imageUrl.trim() !== ""
                                  //       ? newsItem.imageUrl
                                  //       : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0x2fwUoET9YatuWt5NZjc_2KiDFUCLF4k8w&s"
                                  //   }
                                  //   alt="News thumbnail"
                                  // />
                                  image={(() => {
                                    const imageUrls = [
                                      "https://news.ufl.edu/media/newsufledu/images/2021/12/supply-chain.jpg",
                                      "https://cdn.prod.website-files.com/630b302c741fe7a987396dd0/63ac83827a881de06792b095_top-supply-chain-events-p-1080.jpg",
                                      "https://www.shipbob.com/wp-content/uploads/2021/06/supply-chain-technology.jpg",
                                    ];
                                    const randomIndex = Math.floor(
                                      Math.random() * imageUrls.length
                                    );
                                    return imageUrls[randomIndex];
                                  })()}
                                  alt="News thumbnail"
                                />

                                <CardContent
                                  sx={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    color: "white",
                                    fontSize: "0.8rem",
                                    padding: "8px",
                                    "&:last-child": { paddingBottom: "8px" },
                                    minHeight: 0,
                                    overflow: "hidden",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontStyle: "Roboto",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      lineHeight: "16.94px",
                                      textAlign: "left",
                                      mb: 0.5,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: "vertical",
                                      pr: "40px", // Add right padding to prevent overlap with IconButton
                                    }}
                                  >
                                    {newsItem.title}
                                  </Typography>
                                  {/* <Typography
                            
                            sx={{
                              fontStyle: "Roboto",
                              fontSize: "12px",
                              fontWeight: 500,
                              lineHeight: "16.94px",
                              textAlign: "left",
                              color: "#FFFFFF66",
                              mb: 0.5,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {/* <a
                              href={newsItem.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            > */}
                                  {/* {newsItem.snippet} */}
                                  {/* </a> */}
                                  {/* </Typography> */}
                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: 1,
                                      mt: "0.2rem", // Push content to bottom
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontStyle: "Roboto",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          lineHeight: "16.94px",
                                          color: "#FFFFFF66",
                                        }}
                                      >
                                        {newsItem.source}
                                      </Typography>

                                      {/* Bullet point separator */}
                                      <Box
                                        sx={{
                                          width: "4px",
                                          height: "4px",
                                          borderRadius: "50%",
                                          backgroundColor:
                                            "rgba(255, 255, 255, 0.4)",
                                        }}
                                      />

                                      <Typography
                                        sx={{
                                          fontStyle: "Roboto",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          lineHeight: "16.94px",
                                          color: "rgba(255, 255, 255, 0.7)",
                                        }}
                                      >
                                        {/* {newsItem.date
          ? (() => {
              const parts = newsItem.date.split(",");
              return parts.length > 2
                ? parts.slice(0, 2).join(",")
                : newsItem.date;
            })()
          : "no date"} */}
                                        {getTimeAgo(
                                          parseRelativeDate(newsItem.date)
                                        )}
                                      </Typography>
                                    </Box>
                                    {newsItem.link &&
                                      Object.keys(indiSummaries).length > 0 && (
                                        <Box
                                          sx={{
                                            mt: 1,
                                            pt: 1,
                                            borderTop:
                                              "1px solid rgba(255, 255, 255, 0.2)",
                                            width: "100%",
                                            // backgroundColor: "#FFFFFF0F",
                                            // borderRadius: "8px",
                                            // padding: "8px",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontSize: "12px",
                                              fontWeight: 600,
                                              fontStyle: "Roboto",
                                              mb: 0.5,
                                              color: "rgba(255, 255, 255, 0.8)",
                                            }}
                                          >
                                            <AutoAwesome
                                              sx={{
                                                mr: 0.1,
                                                width: "16px",
                                                height: "16px",
                                              }}
                                            />
                                            Insights
                                          </Typography>
                                          {indiSummaries?.[categoryName]?.[
                                            selectedL3Category
                                          ] &&
                                            Object.entries(
                                              indiSummaries[categoryName][
                                                selectedL3Category
                                              ]
                                            ).map(([link, data]) => {
                                              if (
                                                link === newsItem.link &&
                                                Array.isArray(data.summary)
                                              ) {
                                                return (
                                                  <ul
                                                    key={link}
                                                    style={{
                                                      margin: 0,
                                                      paddingLeft: "20px",
                                                      listStyleType: "disc",
                                                      fontSize: "12px",
                                                    }}
                                                  >
                                                    {data.summary.map(
                                                      (item, idx) => (
                                                        <li
                                                          key={idx}
                                                          style={{
                                                            color:
                                                              "rgba(255, 255, 255, 0.7)",
                                                            marginBottom: "4px",
                                                            fontSize: "12px",
                                                            fontWeight: 400,
                                                            fontStyle: "Roboto",
                                                            lineHeight: "16px",
                                                          }}
                                                        >
                                                          {item}
                                                        </li>
                                                      )
                                                    )}
                                                  </ul>
                                                );
                                              }
                                              return null;
                                            })}
                                        </Box>
                                      )}
                                  </Box>
                                </CardContent>
                              </Card>
                            </div>
                          ))}
                      </div>
                    </>
                  ) : (
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="100%"
                      minHeight="200px"
                    >
                      <LoadingGif />
                      <Typography
                        sx={{
                          fontStyle: "Roboto",
                          fontSize: "14px",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        <i>Fetching Latest Market Insights for you..</i>
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* here */}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "1rem" }}>
            {/* <Card
            sx={{
              backgroundColor: "rgba(129, 129, 129, 0.25)",
              boxShadow: "none",
              border: "1px solid rgba(255, 255, 255, 0.5)",
              borderRadius: "8px",
              width: "100%",
              overflow: "hidden",
            }}
          >
           <CardContent
  sx={{
    color: "white",
    padding: "16px",
    "&:last-child": { paddingBottom: "16px" },
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontStyle: "Roboto",
      fontSize: "14px",
      fontWeight: 700,
      marginBottom: "8px",
    }}
  >
    <Insights sx={{ mr: 0.3, fontSize: "20px" }} /> Market Summary
  </Typography>

  {/* <Typography
    
    sx={{
      fontStyle: "Roboto",
      fontSize: "13px",
      fontWeight: 600,
      marginTop: "16px",
      marginBottom: "8px",
    }}
  >
    Overall Market Overview
  </Typography> */}
            {/* {formattedContent} */}

            {/* <Typography
    
    sx={{
      fontStyle: "Roboto",
      fontSize: "13px",
      fontWeight: 600,
      marginTop: "16px",
      marginBottom: "8px",
    }}
  >
    Cost Structure Insights
  </Typography> */}
            {/* <Typography 
    sx={{
      fontStyle: "Roboto",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: 1.5,
    }}
  >
    {cs_summary}
  </Typography> */}
            {/* </CardContent>
          </Card> */}
          </Grid>
        </Grid>

        {/* News Overlay Dialog */}
        <Dialog
          open={showNewsOverlay}
          onClose={() => setShowNewsOverlay(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              backgroundImage: `url(${bggenai})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundColor: "rgba(129, 129, 129)",
              boxShadow: "none",
            },
          }}
        >
          <DialogTitle sx={{ color: "white", fontSize: "0.9rem" }}>
            Latest Market Insights
            <IconButton
              onClick={() => setShowNewsOverlay(false)}
              sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{ borderColor: "rgba(255, 255, 255,0.5)" }}
          >
            {selectedCategoryNews
              .filter(
                (newsItem, index, self) =>
                  index ===
                  self.findIndex((item) => item.title === newsItem.title)
              )
              // .sort((a, b) => parseRelativeDate(b.date) - parseRelativeDate(a.date))
              .sort((a, b) => {
                const dateA = parseRelativeDate(a.date);
                const dateB = parseRelativeDate(b.date);
                return dateB - dateA;
              })
              // .slice(0, 3)
              .map((newsItem, index) => (
                <div key={index} className="news-card">
                  <Card
                    // key={index}
                    sx={{
                      mb: 2,
                      display: "flex",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      border: "1px solid rgba(255, 255, 255, 0.5)",
                      borderRadius: "8px",
                      width: "100%",
                      // height: "120px",
                      flexDirection: { xs: "column", sm: "row" },
                      overflow: "hidden",
                      position: "relative",
                    }}
                  >
                    <IconButton
                      onClick={() => window.open(newsItem.link, "_blank")}
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "white",
                        zIndex: 10,
                        // border: '1px solid #BE3FF5',
                        // borderRadius: '4px',
                        background: "#FFFFFF0",
                      }}
                    >
                      <OpenInNew
                        style={{
                          marginRight: "0.3rem",
                          height: "16px",
                          width: "16px",
                        }}
                      />
                    </IconButton>
                    <CardMedia
                      component="img"
                      sx={{
                        width: { xs: "100%", sm: "100px" },
                        // height: { xs: "140px", sm: "140px" },
                        objectFit: "cover",
                      }}
                      //   image={
                      //     newsItem.imageUrl &&
                      //     newsItem.imageUrl.trim() !== ""
                      //       ? newsItem.imageUrl
                      //       : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT0x2fwUoET9YatuWt5NZjc_2KiDFUCLF4k8w&s"
                      //   }
                      //   alt="News thumbnail"
                      // />
                      image={(() => {
                        const imageUrls = [
                          "https://news.ufl.edu/media/newsufledu/images/2021/12/supply-chain.jpg",
                          "https://cdn.prod.website-files.com/630b302c741fe7a987396dd0/63ac83827a881de06792b095_top-supply-chain-events-p-1080.jpg",
                          "https://www.shipbob.com/wp-content/uploads/2021/06/supply-chain-technology.jpg",
                        ];
                        const randomIndex = Math.floor(
                          Math.random() * imageUrls.length
                        );
                        return imageUrls[randomIndex];
                      })()}
                      alt="News thumbnail"
                    />

                    <CardContent
                      sx={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        color: "white",
                        fontSize: "0.8rem",
                        padding: "8px",
                        "&:last-child": { paddingBottom: "8px" },
                        minHeight: 0,
                        overflow: "hidden",
                      }}
                    >
                      <Typography
                        sx={{
                          fontStyle: "Roboto",
                          fontSize: "12px",
                          fontWeight: 500,
                          lineHeight: "16.94px",
                          textAlign: "left",
                          mb: 0.5,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          pr: "40px", // Add right padding to prevent overlap with IconButton
                        }}
                      >
                        {newsItem.title}
                      </Typography>
                      {/* <Typography
                            
                            sx={{
                              fontStyle: "Roboto",
                              fontSize: "12px",
                              fontWeight: 500,
                              lineHeight: "16.94px",
                              textAlign: "left",
                              color: "#FFFFFF66",
                              mb: 0.5,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {/* <a
                              href={newsItem.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                textDecoration: "none",
                                color: "inherit",
                              }}
                            > */}
                      {/* {newsItem.snippet} */}
                      {/* </a> */}
                      {/* </Typography> */}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                          mt: "0.2rem", // Push content to bottom
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                          }}
                        >
                          <Typography
                            sx={{
                              fontStyle: "Roboto",
                              fontSize: "12px",
                              fontWeight: 500,
                              lineHeight: "16.94px",
                              color: "#FFFFFF66",
                            }}
                          >
                            {newsItem.source}
                          </Typography>

                          {/* Bullet point separator */}
                          <Box
                            sx={{
                              width: "4px",
                              height: "4px",
                              borderRadius: "50%",
                              backgroundColor: "rgba(255, 255, 255, 0.4)",
                            }}
                          />

                          <Typography
                            sx={{
                              fontStyle: "Roboto",
                              fontSize: "12px",
                              fontWeight: 500,
                              lineHeight: "16.94px",
                              color: "rgba(255, 255, 255, 0.7)",
                            }}
                          >
                            {/* {newsItem.date
          ? (() => {
              const parts = newsItem.date.split(",");
              return parts.length > 2
                ? parts.slice(0, 2).join(",")
                : newsItem.date;
            })()
          : "no date"} */}
                            {getTimeAgo(parseRelativeDate(newsItem.date))}
                          </Typography>
                        </Box>
                        {newsItem.link &&
                          Object.keys(indiSummaries).length > 0 && (
                            <Box
                              sx={{
                                mt: 1,
                                pt: 1,
                                borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                                width: "100%",
                                // backgroundColor: "#FFFFFF0F",
                                // borderRadius: "8px",
                                // padding: "8px",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  fontStyle: "Roboto",
                                  mb: 0.5,
                                  color: "rgba(255, 255, 255, 0.8)",
                                }}
                              >
                                <AutoAwesome
                                  sx={{
                                    mr: 0.1,
                                    width: "16px",
                                    height: "16px",
                                  }}
                                />
                                Insights
                              </Typography>
                              {indiSummaries?.[categoryName]?.[
                                selectedL3Category
                              ] &&
                                Object.entries(
                                  indiSummaries[categoryName][
                                    selectedL3Category
                                  ]
                                ).map(([link, data]) => {
                                  if (
                                    link === newsItem.link &&
                                    Array.isArray(data.summary)
                                  ) {
                                    return (
                                      <ul
                                        key={link}
                                        style={{
                                          margin: 0,
                                          paddingLeft: "20px",
                                          listStyleType: "disc",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {data.summary.map((item, idx) => (
                                          <li
                                            key={idx}
                                            style={{
                                              color: "rgba(255, 255, 255, 0.7)",
                                              marginBottom: "4px",
                                              fontSize: "12px",
                                              fontWeight: 400,
                                              fontStyle: "Roboto",
                                              lineHeight: "16px",
                                            }}
                                          >
                                            {item}
                                          </li>
                                        ))}
                                      </ul>
                                    );
                                  }
                                  return null;
                                })}
                            </Box>
                          )}
                      </Box>
                    </CardContent>
                  </Card>
                  {/* Render Summary if available */}
                  {/* Render Summary if available */}
                </div>
              ))}
          </DialogContent>
        </Dialog>
      </Box>

      <div>
        {/* {filteredResults.result && Object.keys(filteredResults.result).length > 0 ? (
    <CommodityPriceChart
      filteredResults={filteredResults.result}
      costStructureMovements={costStructureMovements}
      selectedL3Category={selectedL3Category}
    />
  ) : (
    <LoadingGif />
  )} */}
      </div>
    </>
  );
};
